/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptOrganizationInvitationRequestRequest,
  AsyncDirectOfferResponse,
  BulkDismissRequestRequest,
  BulkRemindRequestRequest,
  BulkRemindResponse,
  BulkUpdateBonusRequestRequest,
  CheckHighDemandRequestRequest,
  CheckHighDemandResponse,
  ClockKioskLink,
  CustomValidationError,
  DirectOffer,
  DirectOfferNoteRule,
  DirectOfferOvertimeRule,
  DirectOfferRequest,
  DirectOfferV2Request,
  GigClockCode,
  GigManagement,
  GigManagementPartialUpdate,
  GigManagementRequest,
  GigShiftSerializerWithGigs,
  GigShiftTemplate,
  GigShiftTemplateReadonly,
  GigShiftTemplateRequest,
  GigShiftUpdate,
  GigsterBlockMultiLocation,
  GigsterBlockMultiLocationRequest,
  GigsterBlockReadOnly,
  GigsterProfileExtendedReadonly,
  GrantedProsBonusRequestRequest,
  GrantedProsBonusResponse,
  GrantedProsDismissRequestRequest,
  GrantedProsQueuedResponse,
  GrantedProsRemindRequestRequest,
  GrantedProsRevokedResponse,
  InvoicingLinkNotFound,
  LocationManager,
  OrgBillingInfo,
  OrgSetupIntentResponse,
  OrganizationGigCandidate,
  OrganizationInvitation,
  OrganizationInvitationRequest,
  OrganizationListResponse,
  OrganizationManager,
  OrganizationPartialUpdate,
  OrganizationRetrieveResponse,
  PaginatedFastUnpaidGigApplicationList,
  PaginatedFastUnratedGigApplicationList,
  PaginatedFilteredGigsterReadOnlyList,
  PaginatedFindProList,
  PaginatedGigDirectOfferReadonlyList,
  PaginatedStafferGigHistoryReadonlyList,
  PaginatedStafferGigViewReadonlyList,
  PaginatedStafferGigViewReadonlySerializerV2List,
  PaginatedStafferPastHireList,
  PatchedGigManagementPartialUpdateRequest,
  PatchedGigShiftTemplateRequest,
  PatchedGigShiftUpdateRequest,
  PatchedOrganizationPartialUpdateRequest,
  PatchedStafferGigApplicationUpdateRequest,
  PatchedStafferGigBulkSettingsRequest,
  PatchedStafferGigUpdateRequest,
  PatchedTipRequest,
  PatchedUpdateApplicationBonusRequestRequest,
  PatchedWorkHistoryRecordRequest,
  PreviewRecurringGig,
  ProAvailability,
  RecurringPatternPreviewList,
  RecurringPatternPreviewQueryRequest,
  RecurringPatternWithTimezone,
  StafferDirectOffersCreateParams,
  StafferDirectOffersOvertimeRuleRetrieveParams,
  StafferFailedOfferDeclineList,
  StafferGigApplication,
  StafferGigApplicationCreateResponse,
  StafferGigApplicationUpdateRequest,
  StafferGigApplicationsCreateParams,
  StafferGigApplicationsFailedOfferDeclinesRetrieveParams,
  StafferGigApplicationsList200,
  StafferGigApplicationsListParams,
  StafferGigApplicationsRecurringCreateParams,
  StafferGigApplicationsUnpaidListParams,
  StafferGigApplicationsUnratedListParams,
  StafferGigBulkSettingsResponse,
  StafferGigCloseShift,
  StafferGigCloseShiftRequest,
  StafferGigCreate,
  StafferGigCreateRequest,
  StafferGigDetailReadonlyApplication,
  StafferGigDetailViewReadonly,
  StafferGigUpdate,
  StafferGigUpdateRequest,
  StafferGigViewReadonlyRetrieveSerializerV2,
  StafferGigViewReadonlySerializerV3,
  StafferGigsCreateParams,
  StafferGigsDirectOfferListParams,
  StafferGigsGigManagementListParams,
  StafferGigsHistoryBySkillListParams,
  StafferGigsListParams,
  StafferGigsPartialUpdateParams,
  StafferGigsTemplatesListParams,
  StafferGigsV2CalendarListParams,
  StafferGigsV2CreateParams,
  StafferGigsV2ListParams,
  StafferGigsV2PartialUpdateParams,
  StafferGigsV2RecurringPatternGigsListParams,
  StafferGigsterProfilesAvailabilityListParams,
  StafferGigsterProfilesListParams,
  StafferGigsterProfilesSearchListParams,
  StafferOrganizationsGigsListParams,
  StafferOrganizationsListParams,
  StafferOrganizationsShiftsListParams,
  StafferPastHiresListParams,
  StafferProBlockListParams,
  StafferProPreferences,
  StafferProPreferencesRequest,
  StafferTimeAndAttendanceRosterPdfRetrieveParams,
  StafferTimeAndAttendanceStatsRetrieveParams,
  TimeAndAttendanceStats,
  Timesheet,
  Tip,
  TipRequest,
  TosStatus,
  UpdateApplicationBonusResponse,
  UserResponse,
  WorkHistoryRecord,
  WorkHistoryRecordRequest
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getStafferDirectOffersCreateUrl = (params?: StafferDirectOffersCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/direct-offers/?${stringifiedParams}` : `/api/staffer/direct-offers/`
}

/**
 * This Endpoint is used for managers to send direct offers to Pros. Internally, it will run the same validations used in the Select Applicant endpoint and also it will send the same push notification of selection to the Pro.
 */
export const stafferDirectOffersCreate = async (directOfferV2Request: DirectOfferV2Request,
    params?: StafferDirectOffersCreateParams, options?: Parameters<typeof customFetch>[1]): Promise<AsyncDirectOfferResponse | StafferGigApplication[] | DirectOfferV2Request | CustomValidationError> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AsyncDirectOfferResponse | StafferGigApplication[] | DirectOfferV2Request | CustomValidationError>(getStafferDirectOffersCreateUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(directOfferV2Request)
  }
);}





export const getStafferDirectOffersCreateMutationKey = () => ['stafferDirectOffersCreate'] as const;

export const getStafferDirectOffersCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferDirectOffersCreate>>, TError,StafferDirectOffersCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferDirectOffersCreate>>, TError,StafferDirectOffersCreateMutationVariables, TContext> => {

const mutationKey = getStafferDirectOffersCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferDirectOffersCreate>>, StafferDirectOffersCreateMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  stafferDirectOffersCreate(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferDirectOffersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferDirectOffersCreate>>>
    export type StafferDirectOffersCreateMutationBody = DirectOfferV2Request
    export type StafferDirectOffersCreateMutationError = void
    export type StafferDirectOffersCreateMutationVariables = {data: DirectOfferV2Request;params?: StafferDirectOffersCreateParams}

    export const useStafferDirectOffersCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferDirectOffersCreate>>, TError,StafferDirectOffersCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferDirectOffersCreate>>,
        TError,
        StafferDirectOffersCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferDirectOffersCreateMutationOptions(options), queryClient);
    }
    export const getStafferDirectOffersNoteRuleRetrieveUrl = () => {




  return `/api/staffer/direct-offers/note-rule/`
}

/**
 * The send size from which an admin must say why they are sending direct offers (CORE-8902).
 */
export const stafferDirectOffersNoteRuleRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<DirectOfferNoteRule> => {

  return customFetch<DirectOfferNoteRule>(getStafferDirectOffersNoteRuleRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferDirectOffersNoteRuleRetrieveQueryKey = () => {
    return [
    `/api/staffer/direct-offers/note-rule/`
    ] as const;
    }


export const getStafferDirectOffersNoteRuleRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferDirectOffersNoteRuleRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferDirectOffersNoteRuleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferDirectOffersNoteRuleRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferDirectOffersNoteRuleRetrieve>>> = ({ signal }) => stafferDirectOffersNoteRuleRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferDirectOffersNoteRuleRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferDirectOffersNoteRuleRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferDirectOffersNoteRuleRetrieve>>>
export type StafferDirectOffersNoteRuleRetrieveQueryError = void


export function useStafferDirectOffersNoteRuleRetrieve<TData = Awaited<ReturnType<typeof stafferDirectOffersNoteRuleRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferDirectOffersNoteRuleRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferDirectOffersNoteRuleRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferDirectOffersNoteRuleRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferDirectOffersNoteRuleRetrieve<TData = Awaited<ReturnType<typeof stafferDirectOffersNoteRuleRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferDirectOffersNoteRuleRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferDirectOffersNoteRuleRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferDirectOffersNoteRuleRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferDirectOffersNoteRuleRetrieve<TData = Awaited<ReturnType<typeof stafferDirectOffersNoteRuleRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferDirectOffersNoteRuleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferDirectOffersNoteRuleRetrieve<TData = Awaited<ReturnType<typeof stafferDirectOffersNoteRuleRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferDirectOffersNoteRuleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferDirectOffersNoteRuleRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferDirectOffersOvertimeRuleRetrieveUrl = (params: StafferDirectOffersOvertimeRuleRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/direct-offers/overtime-rule/?${stringifiedParams}` : `/api/staffer/direct-offers/overtime-rule/`
}

/**
 * Whether the admin must pick what happens to pros this gig would put over 40 hours, and at what rate.
 */
export const stafferDirectOffersOvertimeRuleRetrieve = async (params: StafferDirectOffersOvertimeRuleRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<DirectOfferOvertimeRule> => {

  return customFetch<DirectOfferOvertimeRule>(getStafferDirectOffersOvertimeRuleRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferDirectOffersOvertimeRuleRetrieveQueryKey = (params?: StafferDirectOffersOvertimeRuleRetrieveParams,) => {
    return [
    `/api/staffer/direct-offers/overtime-rule/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferDirectOffersOvertimeRuleRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferDirectOffersOvertimeRuleRetrieve>>, TError = void>(params: StafferDirectOffersOvertimeRuleRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferDirectOffersOvertimeRuleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferDirectOffersOvertimeRuleRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferDirectOffersOvertimeRuleRetrieve>>> = ({ signal }) => stafferDirectOffersOvertimeRuleRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferDirectOffersOvertimeRuleRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferDirectOffersOvertimeRuleRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferDirectOffersOvertimeRuleRetrieve>>>
export type StafferDirectOffersOvertimeRuleRetrieveQueryError = void


export function useStafferDirectOffersOvertimeRuleRetrieve<TData = Awaited<ReturnType<typeof stafferDirectOffersOvertimeRuleRetrieve>>, TError = void>(
 params: StafferDirectOffersOvertimeRuleRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferDirectOffersOvertimeRuleRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferDirectOffersOvertimeRuleRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferDirectOffersOvertimeRuleRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferDirectOffersOvertimeRuleRetrieve<TData = Awaited<ReturnType<typeof stafferDirectOffersOvertimeRuleRetrieve>>, TError = void>(
 params: StafferDirectOffersOvertimeRuleRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferDirectOffersOvertimeRuleRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferDirectOffersOvertimeRuleRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferDirectOffersOvertimeRuleRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferDirectOffersOvertimeRuleRetrieve<TData = Awaited<ReturnType<typeof stafferDirectOffersOvertimeRuleRetrieve>>, TError = void>(
 params: StafferDirectOffersOvertimeRuleRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferDirectOffersOvertimeRuleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferDirectOffersOvertimeRuleRetrieve<TData = Awaited<ReturnType<typeof stafferDirectOffersOvertimeRuleRetrieve>>, TError = void>(
 params: StafferDirectOffersOvertimeRuleRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferDirectOffersOvertimeRuleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferDirectOffersOvertimeRuleRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigApplicationsListUrl = (params: StafferGigApplicationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gig-applications/?${stringifiedParams}` : `/api/staffer/gig-applications/`
}

export const stafferGigApplicationsList = async (params: StafferGigApplicationsListParams, options?: Parameters<typeof customFetch>[1]): Promise<StafferGigApplicationsList200> => {

  return customFetch<StafferGigApplicationsList200>(getStafferGigApplicationsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigApplicationsListInfiniteQueryKey = (params?: StafferGigApplicationsListParams,) => {
    return [
    'infinite', `/api/staffer/gig-applications/`, ...(params ? [params] : [])
    ] as const;
    }

export const getStafferGigApplicationsListQueryKey = (params?: StafferGigApplicationsListParams,) => {
    return [
    `/api/staffer/gig-applications/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferGigApplicationsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof stafferGigApplicationsList>>, StafferGigApplicationsListParams['page']>, TError = void>(params: StafferGigApplicationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsList>>, TError, TData, QueryKey, StafferGigApplicationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigApplicationsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigApplicationsList>>, QueryKey, StafferGigApplicationsListParams['page']> = ({ signal, pageParam }) => stafferGigApplicationsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsList>>, TError, TData, QueryKey, StafferGigApplicationsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigApplicationsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsList>>>
export type StafferGigApplicationsListInfiniteQueryError = void


export function useStafferGigApplicationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigApplicationsList>>, StafferGigApplicationsListParams['page']>, TError = void>(
 params: StafferGigApplicationsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsList>>, TError, TData, QueryKey, StafferGigApplicationsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigApplicationsList>>, StafferGigApplicationsListParams['page']>, TError = void>(
 params: StafferGigApplicationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsList>>, TError, TData, QueryKey, StafferGigApplicationsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigApplicationsList>>, StafferGigApplicationsListParams['page']>, TError = void>(
 params: StafferGigApplicationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsList>>, TError, TData, QueryKey, StafferGigApplicationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigApplicationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigApplicationsList>>, StafferGigApplicationsListParams['page']>, TError = void>(
 params: StafferGigApplicationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsList>>, TError, TData, QueryKey, StafferGigApplicationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigApplicationsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigApplicationsListQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigApplicationsList>>, TError = void>(params: StafferGigApplicationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigApplicationsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigApplicationsList>>> = ({ signal }) => stafferGigApplicationsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigApplicationsListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsList>>>
export type StafferGigApplicationsListQueryError = void


export function useStafferGigApplicationsList<TData = Awaited<ReturnType<typeof stafferGigApplicationsList>>, TError = void>(
 params: StafferGigApplicationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsList<TData = Awaited<ReturnType<typeof stafferGigApplicationsList>>, TError = void>(
 params: StafferGigApplicationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsList<TData = Awaited<ReturnType<typeof stafferGigApplicationsList>>, TError = void>(
 params: StafferGigApplicationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigApplicationsList<TData = Awaited<ReturnType<typeof stafferGigApplicationsList>>, TError = void>(
 params: StafferGigApplicationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigApplicationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigApplicationsCreateUrl = (params?: StafferGigApplicationsCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gig-applications/?${stringifiedParams}` : `/api/staffer/gig-applications/`
}

/**
 * This Endpoint is used for managers to send direct offers to Pros. Internally, it will run the same validations used in the Select Applicant endpoint and also it will send the same push notification of selection to the Pro.
 */
export const stafferGigApplicationsCreate = async (directOfferRequest: DirectOfferRequest,
    params?: StafferGigApplicationsCreateParams, options?: Parameters<typeof customFetch>[1]): Promise<StafferGigApplicationCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<StafferGigApplicationCreateResponse>(getStafferGigApplicationsCreateUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(directOfferRequest)
  }
);}





export const getStafferGigApplicationsCreateMutationKey = () => ['stafferGigApplicationsCreate'] as const;

export const getStafferGigApplicationsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsCreate>>, TError,StafferGigApplicationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsCreate>>, TError,StafferGigApplicationsCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigApplicationsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigApplicationsCreate>>, StafferGigApplicationsCreateMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  stafferGigApplicationsCreate(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigApplicationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsCreate>>>
    export type StafferGigApplicationsCreateMutationBody = DirectOfferRequest
    export type StafferGigApplicationsCreateMutationError = void
    export type StafferGigApplicationsCreateMutationVariables = {data: DirectOfferRequest;params?: StafferGigApplicationsCreateParams}

    export const useStafferGigApplicationsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsCreate>>, TError,StafferGigApplicationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigApplicationsCreate>>,
        TError,
        StafferGigApplicationsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigApplicationsCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigApplicationsRetrieveUrl = (id: number,) => {




  return `/api/staffer/gig-applications/${id}/`
}

export const stafferGigApplicationsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<StafferGigDetailReadonlyApplication> => {

  return customFetch<StafferGigDetailReadonlyApplication>(getStafferGigApplicationsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigApplicationsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/staffer/gig-applications/${id}/`
    ] as const;
    }


export const getStafferGigApplicationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigApplicationsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigApplicationsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigApplicationsRetrieve>>> = ({ signal }) => stafferGigApplicationsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigApplicationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsRetrieve>>>
export type StafferGigApplicationsRetrieveQueryError = void


export function useStafferGigApplicationsRetrieve<TData = Awaited<ReturnType<typeof stafferGigApplicationsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsRetrieve<TData = Awaited<ReturnType<typeof stafferGigApplicationsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsRetrieve<TData = Awaited<ReturnType<typeof stafferGigApplicationsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigApplicationsRetrieve<TData = Awaited<ReturnType<typeof stafferGigApplicationsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigApplicationsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigApplicationsUpdateUrl = (id: number,) => {




  return `/api/staffer/gig-applications/${id}/`
}

export const stafferGigApplicationsUpdate = async (id: number,
    stafferGigApplicationUpdateRequest: StafferGigApplicationUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<StafferGigApplication> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<StafferGigApplication>(getStafferGigApplicationsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(stafferGigApplicationUpdateRequest)
  }
);}





export const getStafferGigApplicationsUpdateMutationKey = () => ['stafferGigApplicationsUpdate'] as const;

export const getStafferGigApplicationsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsUpdate>>, TError,StafferGigApplicationsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsUpdate>>, TError,StafferGigApplicationsUpdateMutationVariables, TContext> => {

const mutationKey = getStafferGigApplicationsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigApplicationsUpdate>>, StafferGigApplicationsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  stafferGigApplicationsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigApplicationsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsUpdate>>>
    export type StafferGigApplicationsUpdateMutationBody = StafferGigApplicationUpdateRequest
    export type StafferGigApplicationsUpdateMutationError = void
    export type StafferGigApplicationsUpdateMutationVariables = {id: number;data: StafferGigApplicationUpdateRequest}

    export const useStafferGigApplicationsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsUpdate>>, TError,StafferGigApplicationsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigApplicationsUpdate>>,
        TError,
        StafferGigApplicationsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigApplicationsUpdateMutationOptions(options), queryClient);
    }
    export const getStafferGigApplicationsPartialUpdateUrl = (id: number,) => {




  return `/api/staffer/gig-applications/${id}/`
}

export const stafferGigApplicationsPartialUpdate = async (id: number,
    patchedStafferGigApplicationUpdateRequest?: PatchedStafferGigApplicationUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<StafferGigApplication> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<StafferGigApplication>(getStafferGigApplicationsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedStafferGigApplicationUpdateRequest)
  }
);}





export const getStafferGigApplicationsPartialUpdateMutationKey = () => ['stafferGigApplicationsPartialUpdate'] as const;

export const getStafferGigApplicationsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsPartialUpdate>>, TError,StafferGigApplicationsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsPartialUpdate>>, TError,StafferGigApplicationsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getStafferGigApplicationsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigApplicationsPartialUpdate>>, StafferGigApplicationsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  stafferGigApplicationsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigApplicationsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsPartialUpdate>>>
    export type StafferGigApplicationsPartialUpdateMutationBody = PatchedStafferGigApplicationUpdateRequest | undefined
    export type StafferGigApplicationsPartialUpdateMutationError = void
    export type StafferGigApplicationsPartialUpdateMutationVariables = {id: number;data?: PatchedStafferGigApplicationUpdateRequest}

    export const useStafferGigApplicationsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsPartialUpdate>>, TError,StafferGigApplicationsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigApplicationsPartialUpdate>>,
        TError,
        StafferGigApplicationsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigApplicationsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getStafferGigApplicationsDestroyUrl = (id: number,) => {




  return `/api/staffer/gig-applications/${id}/`
}

export const stafferGigApplicationsDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getStafferGigApplicationsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getStafferGigApplicationsDestroyMutationKey = () => ['stafferGigApplicationsDestroy'] as const;

export const getStafferGigApplicationsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsDestroy>>, TError,StafferGigApplicationsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsDestroy>>, TError,StafferGigApplicationsDestroyMutationVariables, TContext> => {

const mutationKey = getStafferGigApplicationsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigApplicationsDestroy>>, StafferGigApplicationsDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  stafferGigApplicationsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigApplicationsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsDestroy>>>

    export type StafferGigApplicationsDestroyMutationError = void
    export type StafferGigApplicationsDestroyMutationVariables = {id: number}

    export const useStafferGigApplicationsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsDestroy>>, TError,StafferGigApplicationsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigApplicationsDestroy>>,
        TError,
        StafferGigApplicationsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigApplicationsDestroyMutationOptions(options), queryClient);
    }
    export const getStafferGigApplicationsBonusPartialUpdateUrl = (id: number,) => {




  return `/api/staffer/gig-applications/${id}/bonus/`
}

/**
 * Set the boosted bonus on a single application. Snapshot-only — does not touch ``Gig.boosted_gig_bonus``, so the gig-level number advertised on public surfaces is unaffected. Restricted to Gigpro admins (mirrors the gig-level boost rule) and to applications that are not yet confirmed/cancelled, since the snapshot is the value the pro is paid against.
 */
export const stafferGigApplicationsBonusPartialUpdate = async (id: number,
    patchedUpdateApplicationBonusRequestRequest?: PatchedUpdateApplicationBonusRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<UpdateApplicationBonusResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<UpdateApplicationBonusResponse>(getStafferGigApplicationsBonusPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedUpdateApplicationBonusRequestRequest)
  }
);}





export const getStafferGigApplicationsBonusPartialUpdateMutationKey = () => ['stafferGigApplicationsBonusPartialUpdate'] as const;

export const getStafferGigApplicationsBonusPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsBonusPartialUpdate>>, TError,StafferGigApplicationsBonusPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsBonusPartialUpdate>>, TError,StafferGigApplicationsBonusPartialUpdateMutationVariables, TContext> => {

const mutationKey = getStafferGigApplicationsBonusPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigApplicationsBonusPartialUpdate>>, StafferGigApplicationsBonusPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  stafferGigApplicationsBonusPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigApplicationsBonusPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsBonusPartialUpdate>>>
    export type StafferGigApplicationsBonusPartialUpdateMutationBody = PatchedUpdateApplicationBonusRequestRequest | undefined
    export type StafferGigApplicationsBonusPartialUpdateMutationError = void
    export type StafferGigApplicationsBonusPartialUpdateMutationVariables = {id: number;data?: PatchedUpdateApplicationBonusRequestRequest}

    export const useStafferGigApplicationsBonusPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsBonusPartialUpdate>>, TError,StafferGigApplicationsBonusPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigApplicationsBonusPartialUpdate>>,
        TError,
        StafferGigApplicationsBonusPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigApplicationsBonusPartialUpdateMutationOptions(options), queryClient);
    }
    export const getStafferGigApplicationsRemindCreateUrl = (id: number,) => {




  return `/api/staffer/gig-applications/${id}/remind/`
}

/**
 * Re-send the selection push notification to the pro for a previously-offered application. Useful when the manager or admin noticed the pro hasn't responded to a direct offer or selection.
 */
export const stafferGigApplicationsRemindCreate = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getStafferGigApplicationsRemindCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStafferGigApplicationsRemindCreateMutationKey = () => ['stafferGigApplicationsRemindCreate'] as const;

export const getStafferGigApplicationsRemindCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsRemindCreate>>, TError,StafferGigApplicationsRemindCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsRemindCreate>>, TError,StafferGigApplicationsRemindCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigApplicationsRemindCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigApplicationsRemindCreate>>, StafferGigApplicationsRemindCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  stafferGigApplicationsRemindCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigApplicationsRemindCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsRemindCreate>>>

    export type StafferGigApplicationsRemindCreateMutationError = void
    export type StafferGigApplicationsRemindCreateMutationVariables = {id: number}

    export const useStafferGigApplicationsRemindCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsRemindCreate>>, TError,StafferGigApplicationsRemindCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigApplicationsRemindCreate>>,
        TError,
        StafferGigApplicationsRemindCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigApplicationsRemindCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigApplicationsTimesheetRetrieveUrl = (id: number,) => {




  return `/api/staffer/gig-applications/${id}/timesheet/`
}

export const stafferGigApplicationsTimesheetRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<Timesheet> => {

  return customFetch<Timesheet>(getStafferGigApplicationsTimesheetRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigApplicationsTimesheetRetrieveQueryKey = (id: number,) => {
    return [
    `/api/staffer/gig-applications/${id}/timesheet/`
    ] as const;
    }


export const getStafferGigApplicationsTimesheetRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigApplicationsTimesheetRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsTimesheetRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigApplicationsTimesheetRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigApplicationsTimesheetRetrieve>>> = ({ signal }) => stafferGigApplicationsTimesheetRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsTimesheetRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigApplicationsTimesheetRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsTimesheetRetrieve>>>
export type StafferGigApplicationsTimesheetRetrieveQueryError = void


export function useStafferGigApplicationsTimesheetRetrieve<TData = Awaited<ReturnType<typeof stafferGigApplicationsTimesheetRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsTimesheetRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsTimesheetRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsTimesheetRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsTimesheetRetrieve<TData = Awaited<ReturnType<typeof stafferGigApplicationsTimesheetRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsTimesheetRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsTimesheetRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsTimesheetRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsTimesheetRetrieve<TData = Awaited<ReturnType<typeof stafferGigApplicationsTimesheetRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsTimesheetRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigApplicationsTimesheetRetrieve<TData = Awaited<ReturnType<typeof stafferGigApplicationsTimesheetRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsTimesheetRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigApplicationsTimesheetRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigApplicationsTipsCreateUrl = (id: number,) => {




  return `/api/staffer/gig-applications/${id}/tips/`
}

export const stafferGigApplicationsTipsCreate = async (id: number,
    tipRequest: TipRequest, options?: Parameters<typeof customFetch>[1]): Promise<Tip> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Tip>(getStafferGigApplicationsTipsCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(tipRequest)
  }
);}





export const getStafferGigApplicationsTipsCreateMutationKey = () => ['stafferGigApplicationsTipsCreate'] as const;

export const getStafferGigApplicationsTipsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsTipsCreate>>, TError,StafferGigApplicationsTipsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsTipsCreate>>, TError,StafferGigApplicationsTipsCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigApplicationsTipsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigApplicationsTipsCreate>>, StafferGigApplicationsTipsCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  stafferGigApplicationsTipsCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigApplicationsTipsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsTipsCreate>>>
    export type StafferGigApplicationsTipsCreateMutationBody = TipRequest
    export type StafferGigApplicationsTipsCreateMutationError = void
    export type StafferGigApplicationsTipsCreateMutationVariables = {id: number;data: TipRequest}

    export const useStafferGigApplicationsTipsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsTipsCreate>>, TError,StafferGigApplicationsTipsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigApplicationsTipsCreate>>,
        TError,
        StafferGigApplicationsTipsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigApplicationsTipsCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigApplicationsTipsPartialUpdateUrl = (id: number,) => {




  return `/api/staffer/gig-applications/${id}/tips/`
}

export const stafferGigApplicationsTipsPartialUpdate = async (id: number,
    patchedTipRequest?: PatchedTipRequest, options?: Parameters<typeof customFetch>[1]): Promise<Tip> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Tip>(getStafferGigApplicationsTipsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedTipRequest)
  }
);}





export const getStafferGigApplicationsTipsPartialUpdateMutationKey = () => ['stafferGigApplicationsTipsPartialUpdate'] as const;

export const getStafferGigApplicationsTipsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsTipsPartialUpdate>>, TError,StafferGigApplicationsTipsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsTipsPartialUpdate>>, TError,StafferGigApplicationsTipsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getStafferGigApplicationsTipsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigApplicationsTipsPartialUpdate>>, StafferGigApplicationsTipsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  stafferGigApplicationsTipsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigApplicationsTipsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsTipsPartialUpdate>>>
    export type StafferGigApplicationsTipsPartialUpdateMutationBody = PatchedTipRequest | undefined
    export type StafferGigApplicationsTipsPartialUpdateMutationError = void
    export type StafferGigApplicationsTipsPartialUpdateMutationVariables = {id: number;data?: PatchedTipRequest}

    export const useStafferGigApplicationsTipsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsTipsPartialUpdate>>, TError,StafferGigApplicationsTipsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigApplicationsTipsPartialUpdate>>,
        TError,
        StafferGigApplicationsTipsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigApplicationsTipsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getStafferGigApplicationsBulkBonusCreateUrl = () => {




  return `/api/staffer/gig-applications/bulk-bonus/`
}

/**
 * Apply the same `boosted_gig_bonus` to many applications at once, returning an aggregate count + per-id advisory errors. Per-row lifecycle / raise-only rules run server-side via `GigApplicationService.update_bonus`; failures surface as advisories with their `application_id` so the FE can mark the specific row. Mirrors `bulk_remind` / `bulk_dismiss` so the FE uses a single error-handling pattern across bulk actions.
 */
export const stafferGigApplicationsBulkBonusCreate = async (bulkUpdateBonusRequestRequest: BulkUpdateBonusRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<AsyncDirectOfferResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AsyncDirectOfferResponse>(getStafferGigApplicationsBulkBonusCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkUpdateBonusRequestRequest)
  }
);}





export const getStafferGigApplicationsBulkBonusCreateMutationKey = () => ['stafferGigApplicationsBulkBonusCreate'] as const;

export const getStafferGigApplicationsBulkBonusCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsBulkBonusCreate>>, TError,StafferGigApplicationsBulkBonusCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsBulkBonusCreate>>, TError,StafferGigApplicationsBulkBonusCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigApplicationsBulkBonusCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigApplicationsBulkBonusCreate>>, StafferGigApplicationsBulkBonusCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  stafferGigApplicationsBulkBonusCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigApplicationsBulkBonusCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsBulkBonusCreate>>>
    export type StafferGigApplicationsBulkBonusCreateMutationBody = BulkUpdateBonusRequestRequest
    export type StafferGigApplicationsBulkBonusCreateMutationError = void
    export type StafferGigApplicationsBulkBonusCreateMutationVariables = {data: BulkUpdateBonusRequestRequest}

    export const useStafferGigApplicationsBulkBonusCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsBulkBonusCreate>>, TError,StafferGigApplicationsBulkBonusCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigApplicationsBulkBonusCreate>>,
        TError,
        StafferGigApplicationsBulkBonusCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigApplicationsBulkBonusCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigApplicationsBulkDismissCreateUrl = () => {




  return `/api/staffer/gig-applications/bulk-dismiss/`
}

/**
 * Bulk-cancel a list of GigApplications via the existing `ApplicationCancellation` flow with reason=STAFFER_DISMISSAL. The reason is not client-configurable: any other reason would silently hard-delete unselected applications via `GigApplication.cancel()`'s delete-without-audit branch. Niche flows that need other reasons must use the per-row endpoint. Rows that fail validation surface as advisory errors (with their `application_id`) so the FE can mark the specific row.
 */
export const stafferGigApplicationsBulkDismissCreate = async (bulkDismissRequestRequest: BulkDismissRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<AsyncDirectOfferResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AsyncDirectOfferResponse>(getStafferGigApplicationsBulkDismissCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkDismissRequestRequest)
  }
);}





export const getStafferGigApplicationsBulkDismissCreateMutationKey = () => ['stafferGigApplicationsBulkDismissCreate'] as const;

export const getStafferGigApplicationsBulkDismissCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsBulkDismissCreate>>, TError,StafferGigApplicationsBulkDismissCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsBulkDismissCreate>>, TError,StafferGigApplicationsBulkDismissCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigApplicationsBulkDismissCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigApplicationsBulkDismissCreate>>, StafferGigApplicationsBulkDismissCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  stafferGigApplicationsBulkDismissCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigApplicationsBulkDismissCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsBulkDismissCreate>>>
    export type StafferGigApplicationsBulkDismissCreateMutationBody = BulkDismissRequestRequest
    export type StafferGigApplicationsBulkDismissCreateMutationError = void
    export type StafferGigApplicationsBulkDismissCreateMutationVariables = {data: BulkDismissRequestRequest}

    export const useStafferGigApplicationsBulkDismissCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsBulkDismissCreate>>, TError,StafferGigApplicationsBulkDismissCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigApplicationsBulkDismissCreate>>,
        TError,
        StafferGigApplicationsBulkDismissCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigApplicationsBulkDismissCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigApplicationsBulkRemindCreateUrl = () => {




  return `/api/staffer/gig-applications/bulk-remind/`
}

/**
 * Queue a single bulk push task that fans out the same selection reminder push the per-row `/remind/` action sends — accepts a list of GigApplication ids and optional `custom_title` / `custom_message` overrides, returning an aggregate count + per-id advisory errors. Eligible rows go through one bulk Celery task that calls Firebase `send_each` rather than one task per row. The overrides apply uniformly across the batch. Each advisory carries the original `application_id` so the FE can mark the specific row that failed. Mirrors the bulk Direct Offer endpoint's response shape so the FE can use a single error-handling pattern across bulk actions. When `application_ids` is empty and `gig_id` is provided, reminds every selected-but-unresponsive application on that gig instead, queued in batches of up to 500; `application_ids` wins if both are given. With neither, the call is a no-op (`queued_count: 0`). Admins can add `include_last_call_eligible` / `include_last_call_conversion` in gig mode to also push the pros the shift is open to, paced in the background and refused with a 400 while that audience is cooling down (see the match dashboard `remind-preview`).
 */
export const stafferGigApplicationsBulkRemindCreate = async (bulkRemindRequestRequest: BulkRemindRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<BulkRemindResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BulkRemindResponse>(getStafferGigApplicationsBulkRemindCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkRemindRequestRequest)
  }
);}





export const getStafferGigApplicationsBulkRemindCreateMutationKey = () => ['stafferGigApplicationsBulkRemindCreate'] as const;

export const getStafferGigApplicationsBulkRemindCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsBulkRemindCreate>>, TError,StafferGigApplicationsBulkRemindCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsBulkRemindCreate>>, TError,StafferGigApplicationsBulkRemindCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigApplicationsBulkRemindCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigApplicationsBulkRemindCreate>>, StafferGigApplicationsBulkRemindCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  stafferGigApplicationsBulkRemindCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigApplicationsBulkRemindCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsBulkRemindCreate>>>
    export type StafferGigApplicationsBulkRemindCreateMutationBody = BulkRemindRequestRequest
    export type StafferGigApplicationsBulkRemindCreateMutationError = void
    export type StafferGigApplicationsBulkRemindCreateMutationVariables = {data: BulkRemindRequestRequest}

    export const useStafferGigApplicationsBulkRemindCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsBulkRemindCreate>>, TError,StafferGigApplicationsBulkRemindCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigApplicationsBulkRemindCreate>>,
        TError,
        StafferGigApplicationsBulkRemindCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigApplicationsBulkRemindCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigApplicationsFailedOfferDeclinesRetrieveUrl = (params: StafferGigApplicationsFailedOfferDeclinesRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gig-applications/failed-offer-declines/?${stringifiedParams}` : `/api/staffer/gig-applications/failed-offer-declines/`
}

/**
 * The pros a direct offer on this gig could not be sent to, each with the reason (decline_category: CONFIRMED_ELSEWHERE, SUSPENDED or MISSING_REQUIREMENTS), for the Declined tab. Merge by gigster.id with the applications whose decline_category is set. Unpaginated unless page or page_size is sent. A pro who now holds an application on the gig is left out, so the two sources never overlap. Empty while the declined-offer-reasons flag is off for the gig's location.
 */
export const stafferGigApplicationsFailedOfferDeclinesRetrieve = async (params: StafferGigApplicationsFailedOfferDeclinesRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<StafferFailedOfferDeclineList> => {

  return customFetch<StafferFailedOfferDeclineList>(getStafferGigApplicationsFailedOfferDeclinesRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigApplicationsFailedOfferDeclinesRetrieveQueryKey = (params?: StafferGigApplicationsFailedOfferDeclinesRetrieveParams,) => {
    return [
    `/api/staffer/gig-applications/failed-offer-declines/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferGigApplicationsFailedOfferDeclinesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigApplicationsFailedOfferDeclinesRetrieve>>, TError = void>(params: StafferGigApplicationsFailedOfferDeclinesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsFailedOfferDeclinesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigApplicationsFailedOfferDeclinesRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigApplicationsFailedOfferDeclinesRetrieve>>> = ({ signal }) => stafferGigApplicationsFailedOfferDeclinesRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsFailedOfferDeclinesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigApplicationsFailedOfferDeclinesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsFailedOfferDeclinesRetrieve>>>
export type StafferGigApplicationsFailedOfferDeclinesRetrieveQueryError = void


export function useStafferGigApplicationsFailedOfferDeclinesRetrieve<TData = Awaited<ReturnType<typeof stafferGigApplicationsFailedOfferDeclinesRetrieve>>, TError = void>(
 params: StafferGigApplicationsFailedOfferDeclinesRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsFailedOfferDeclinesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsFailedOfferDeclinesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsFailedOfferDeclinesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsFailedOfferDeclinesRetrieve<TData = Awaited<ReturnType<typeof stafferGigApplicationsFailedOfferDeclinesRetrieve>>, TError = void>(
 params: StafferGigApplicationsFailedOfferDeclinesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsFailedOfferDeclinesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsFailedOfferDeclinesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsFailedOfferDeclinesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsFailedOfferDeclinesRetrieve<TData = Awaited<ReturnType<typeof stafferGigApplicationsFailedOfferDeclinesRetrieve>>, TError = void>(
 params: StafferGigApplicationsFailedOfferDeclinesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsFailedOfferDeclinesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigApplicationsFailedOfferDeclinesRetrieve<TData = Awaited<ReturnType<typeof stafferGigApplicationsFailedOfferDeclinesRetrieve>>, TError = void>(
 params: StafferGigApplicationsFailedOfferDeclinesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsFailedOfferDeclinesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigApplicationsFailedOfferDeclinesRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigApplicationsRecurringCreateUrl = (params?: StafferGigApplicationsRecurringCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gig-applications/recurring/?${stringifiedParams}` : `/api/staffer/gig-applications/recurring/`
}

/**
 * This Endpoint is used for managers to send recurring direct offers to Pros and/or Groups. Internally, it will run the same validations used in the Select Applicant endpoint and also it will send the same push notification of selection to the Pro.
 */
export const stafferGigApplicationsRecurringCreate = async (directOfferRequest: DirectOfferRequest,
    params?: StafferGigApplicationsRecurringCreateParams, options?: Parameters<typeof customFetch>[1]): Promise<DirectOffer> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<DirectOffer>(getStafferGigApplicationsRecurringCreateUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(directOfferRequest)
  }
);}





export const getStafferGigApplicationsRecurringCreateMutationKey = () => ['stafferGigApplicationsRecurringCreate'] as const;

export const getStafferGigApplicationsRecurringCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsRecurringCreate>>, TError,StafferGigApplicationsRecurringCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsRecurringCreate>>, TError,StafferGigApplicationsRecurringCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigApplicationsRecurringCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigApplicationsRecurringCreate>>, StafferGigApplicationsRecurringCreateMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  stafferGigApplicationsRecurringCreate(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigApplicationsRecurringCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsRecurringCreate>>>
    export type StafferGigApplicationsRecurringCreateMutationBody = DirectOfferRequest
    export type StafferGigApplicationsRecurringCreateMutationError = void
    export type StafferGigApplicationsRecurringCreateMutationVariables = {data: DirectOfferRequest;params?: StafferGigApplicationsRecurringCreateParams}

    export const useStafferGigApplicationsRecurringCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigApplicationsRecurringCreate>>, TError,StafferGigApplicationsRecurringCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigApplicationsRecurringCreate>>,
        TError,
        StafferGigApplicationsRecurringCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigApplicationsRecurringCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigApplicationsUnpaidListUrl = (params?: StafferGigApplicationsUnpaidListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gig-applications/unpaid/?${stringifiedParams}` : `/api/staffer/gig-applications/unpaid/`
}

/**
 * Get all unpaid gig applications for a location. Available ordering fields: 'gigster', 'gig', 'gig__skill', 'gig__start_time', 'gig__end_time', 'created_ts'
 */
export const stafferGigApplicationsUnpaidList = async (params?: StafferGigApplicationsUnpaidListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedFastUnpaidGigApplicationList> => {

  return customFetch<PaginatedFastUnpaidGigApplicationList>(getStafferGigApplicationsUnpaidListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigApplicationsUnpaidListInfiniteQueryKey = (params?: StafferGigApplicationsUnpaidListParams,) => {
    return [
    'infinite', `/api/staffer/gig-applications/unpaid/`, ...(params ? [params] : [])
    ] as const;
    }

export const getStafferGigApplicationsUnpaidListQueryKey = (params?: StafferGigApplicationsUnpaidListParams,) => {
    return [
    `/api/staffer/gig-applications/unpaid/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferGigApplicationsUnpaidListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, StafferGigApplicationsUnpaidListParams['page']>, TError = void>(params?: StafferGigApplicationsUnpaidListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, TError, TData, QueryKey, StafferGigApplicationsUnpaidListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigApplicationsUnpaidListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, QueryKey, StafferGigApplicationsUnpaidListParams['page']> = ({ signal, pageParam }) => stafferGigApplicationsUnpaidList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, TError, TData, QueryKey, StafferGigApplicationsUnpaidListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigApplicationsUnpaidListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>>
export type StafferGigApplicationsUnpaidListInfiniteQueryError = void


export function useStafferGigApplicationsUnpaidListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, StafferGigApplicationsUnpaidListParams['page']>, TError = void>(
 params: undefined |  StafferGigApplicationsUnpaidListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, TError, TData, QueryKey, StafferGigApplicationsUnpaidListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsUnpaidListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, StafferGigApplicationsUnpaidListParams['page']>, TError = void>(
 params?: StafferGigApplicationsUnpaidListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, TError, TData, QueryKey, StafferGigApplicationsUnpaidListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsUnpaidListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, StafferGigApplicationsUnpaidListParams['page']>, TError = void>(
 params?: StafferGigApplicationsUnpaidListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, TError, TData, QueryKey, StafferGigApplicationsUnpaidListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigApplicationsUnpaidListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, StafferGigApplicationsUnpaidListParams['page']>, TError = void>(
 params?: StafferGigApplicationsUnpaidListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, TError, TData, QueryKey, StafferGigApplicationsUnpaidListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigApplicationsUnpaidListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigApplicationsUnpaidListQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, TError = void>(params?: StafferGigApplicationsUnpaidListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigApplicationsUnpaidListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>> = ({ signal }) => stafferGigApplicationsUnpaidList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigApplicationsUnpaidListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>>
export type StafferGigApplicationsUnpaidListQueryError = void


export function useStafferGigApplicationsUnpaidList<TData = Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, TError = void>(
 params: undefined |  StafferGigApplicationsUnpaidListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsUnpaidList<TData = Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, TError = void>(
 params?: StafferGigApplicationsUnpaidListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsUnpaidList<TData = Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, TError = void>(
 params?: StafferGigApplicationsUnpaidListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigApplicationsUnpaidList<TData = Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, TError = void>(
 params?: StafferGigApplicationsUnpaidListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnpaidList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigApplicationsUnpaidListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigApplicationsUnratedListUrl = (params?: StafferGigApplicationsUnratedListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gig-applications/unrated/?${stringifiedParams}` : `/api/staffer/gig-applications/unrated/`
}

/**
 * Get all unrated gig applications for a location. Returns confirmed applications for ended gigs where the pro has not been rated. Available ordering fields: 'gigster', 'gig', 'gig__skill', 'gig__start_time', 'gig__end_time', 'created_ts'
 */
export const stafferGigApplicationsUnratedList = async (params?: StafferGigApplicationsUnratedListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedFastUnratedGigApplicationList> => {

  return customFetch<PaginatedFastUnratedGigApplicationList>(getStafferGigApplicationsUnratedListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigApplicationsUnratedListInfiniteQueryKey = (params?: StafferGigApplicationsUnratedListParams,) => {
    return [
    'infinite', `/api/staffer/gig-applications/unrated/`, ...(params ? [params] : [])
    ] as const;
    }

export const getStafferGigApplicationsUnratedListQueryKey = (params?: StafferGigApplicationsUnratedListParams,) => {
    return [
    `/api/staffer/gig-applications/unrated/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferGigApplicationsUnratedListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, StafferGigApplicationsUnratedListParams['page']>, TError = void>(params?: StafferGigApplicationsUnratedListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, TError, TData, QueryKey, StafferGigApplicationsUnratedListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigApplicationsUnratedListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, QueryKey, StafferGigApplicationsUnratedListParams['page']> = ({ signal, pageParam }) => stafferGigApplicationsUnratedList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, TError, TData, QueryKey, StafferGigApplicationsUnratedListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigApplicationsUnratedListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>>
export type StafferGigApplicationsUnratedListInfiniteQueryError = void


export function useStafferGigApplicationsUnratedListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, StafferGigApplicationsUnratedListParams['page']>, TError = void>(
 params: undefined |  StafferGigApplicationsUnratedListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, TError, TData, QueryKey, StafferGigApplicationsUnratedListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsUnratedListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, StafferGigApplicationsUnratedListParams['page']>, TError = void>(
 params?: StafferGigApplicationsUnratedListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, TError, TData, QueryKey, StafferGigApplicationsUnratedListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsUnratedListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, StafferGigApplicationsUnratedListParams['page']>, TError = void>(
 params?: StafferGigApplicationsUnratedListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, TError, TData, QueryKey, StafferGigApplicationsUnratedListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigApplicationsUnratedListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, StafferGigApplicationsUnratedListParams['page']>, TError = void>(
 params?: StafferGigApplicationsUnratedListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, TError, TData, QueryKey, StafferGigApplicationsUnratedListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigApplicationsUnratedListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigApplicationsUnratedListQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, TError = void>(params?: StafferGigApplicationsUnratedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigApplicationsUnratedListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>> = ({ signal }) => stafferGigApplicationsUnratedList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigApplicationsUnratedListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>>
export type StafferGigApplicationsUnratedListQueryError = void


export function useStafferGigApplicationsUnratedList<TData = Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, TError = void>(
 params: undefined |  StafferGigApplicationsUnratedListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsUnratedList<TData = Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, TError = void>(
 params?: StafferGigApplicationsUnratedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigApplicationsUnratedList<TData = Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, TError = void>(
 params?: StafferGigApplicationsUnratedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigApplicationsUnratedList<TData = Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, TError = void>(
 params?: StafferGigApplicationsUnratedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigApplicationsUnratedList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigApplicationsUnratedListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsListUrl = (params?: StafferGigsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gigs/?${stringifiedParams}` : `/api/staffer/gigs/`
}

/**
 * Manage gigs as a staffer.
 *
 * This api allowed users to post and manage gigs from a staffer perspective. Note that the format for filtering by
 * start time and end time is ISO 8601, which looks like this: '2020-08-04T18:10:02+00:00'
 */
export const stafferGigsList = async (params?: StafferGigsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedStafferGigViewReadonlyList> => {

  return customFetch<PaginatedStafferGigViewReadonlyList>(getStafferGigsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsListInfiniteQueryKey = (params?: StafferGigsListParams,) => {
    return [
    'infinite', `/api/staffer/gigs/`, ...(params ? [params] : [])
    ] as const;
    }

export const getStafferGigsListQueryKey = (params?: StafferGigsListParams,) => {
    return [
    `/api/staffer/gigs/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferGigsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsList>>, StafferGigsListParams['page']>, TError = void>(params?: StafferGigsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsList>>, TError, TData, QueryKey, StafferGigsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsList>>, QueryKey, StafferGigsListParams['page']> = ({ signal, pageParam }) => stafferGigsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsList>>, TError, TData, QueryKey, StafferGigsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsList>>>
export type StafferGigsListInfiniteQueryError = void


export function useStafferGigsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsList>>, StafferGigsListParams['page']>, TError = void>(
 params: undefined |  StafferGigsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsList>>, TError, TData, QueryKey, StafferGigsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsList>>, StafferGigsListParams['page']>, TError = void>(
 params?: StafferGigsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsList>>, TError, TData, QueryKey, StafferGigsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsList>>, StafferGigsListParams['page']>, TError = void>(
 params?: StafferGigsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsList>>, TError, TData, QueryKey, StafferGigsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsList>>, StafferGigsListParams['page']>, TError = void>(
 params?: StafferGigsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsList>>, TError, TData, QueryKey, StafferGigsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsListQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsList>>, TError = void>(params?: StafferGigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsList>>> = ({ signal }) => stafferGigsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsList>>>
export type StafferGigsListQueryError = void


export function useStafferGigsList<TData = Awaited<ReturnType<typeof stafferGigsList>>, TError = void>(
 params: undefined |  StafferGigsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsList<TData = Awaited<ReturnType<typeof stafferGigsList>>, TError = void>(
 params?: StafferGigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsList<TData = Awaited<ReturnType<typeof stafferGigsList>>, TError = void>(
 params?: StafferGigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsList<TData = Awaited<ReturnType<typeof stafferGigsList>>, TError = void>(
 params?: StafferGigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsCreateUrl = (params?: StafferGigsCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gigs/?${stringifiedParams}` : `/api/staffer/gigs/`
}

/**
 * Manage gigs as a staffer.
 *
 * This api allowed users to post and manage gigs from a staffer perspective. Note that the format for filtering by
 * start time and end time is ISO 8601, which looks like this: '2020-08-04T18:10:02+00:00'
 */
export const stafferGigsCreate = async (stafferGigCreateRequest: StafferGigCreateRequest,
    params?: StafferGigsCreateParams, options?: Parameters<typeof customFetch>[1]): Promise<void | StafferGigCreate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<void | StafferGigCreate>(getStafferGigsCreateUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(stafferGigCreateRequest)
  }
);}





export const getStafferGigsCreateMutationKey = () => ['stafferGigsCreate'] as const;

export const getStafferGigsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsCreate>>, TError,StafferGigsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsCreate>>, TError,StafferGigsCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsCreate>>, StafferGigsCreateMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  stafferGigsCreate(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsCreate>>>
    export type StafferGigsCreateMutationBody = StafferGigCreateRequest
    export type StafferGigsCreateMutationError = void
    export type StafferGigsCreateMutationVariables = {data: StafferGigCreateRequest;params?: StafferGigsCreateParams}

    export const useStafferGigsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsCreate>>, TError,StafferGigsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsCreate>>,
        TError,
        StafferGigsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigsGrantedProsBonusCreateUrl = (gigId: number,) => {




  return `/api/staffer/gigs/${gigId}/granted-pros/bonus/`
}

/**
 * Raise these granted Pros' bonus; raise-only, no push.
 */
export const stafferGigsGrantedProsBonusCreate = async (gigId: number,
    grantedProsBonusRequestRequest: GrantedProsBonusRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<GrantedProsBonusResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GrantedProsBonusResponse>(getStafferGigsGrantedProsBonusCreateUrl(gigId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(grantedProsBonusRequestRequest)
  }
);}





export const getStafferGigsGrantedProsBonusCreateMutationKey = () => ['stafferGigsGrantedProsBonusCreate'] as const;

export const getStafferGigsGrantedProsBonusCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGrantedProsBonusCreate>>, TError,StafferGigsGrantedProsBonusCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGrantedProsBonusCreate>>, TError,StafferGigsGrantedProsBonusCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigsGrantedProsBonusCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsGrantedProsBonusCreate>>, StafferGigsGrantedProsBonusCreateMutationVariables> = (props) => {
          const {gigId,data} = props ?? {};

          return  stafferGigsGrantedProsBonusCreate(gigId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsGrantedProsBonusCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsGrantedProsBonusCreate>>>
    export type StafferGigsGrantedProsBonusCreateMutationBody = GrantedProsBonusRequestRequest
    export type StafferGigsGrantedProsBonusCreateMutationError = void
    export type StafferGigsGrantedProsBonusCreateMutationVariables = {gigId: number;data: GrantedProsBonusRequestRequest}

    export const useStafferGigsGrantedProsBonusCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGrantedProsBonusCreate>>, TError,StafferGigsGrantedProsBonusCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsGrantedProsBonusCreate>>,
        TError,
        StafferGigsGrantedProsBonusCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsGrantedProsBonusCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigsGrantedProsDismissCreateUrl = (gigId: number,) => {




  return `/api/staffer/gigs/${gigId}/granted-pros/dismiss/`
}

/**
 * Withdraw the grant from these Pros: they can no longer see or claim the shift.
 */
export const stafferGigsGrantedProsDismissCreate = async (gigId: number,
    grantedProsDismissRequestRequest: GrantedProsDismissRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<GrantedProsRevokedResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GrantedProsRevokedResponse>(getStafferGigsGrantedProsDismissCreateUrl(gigId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(grantedProsDismissRequestRequest)
  }
);}





export const getStafferGigsGrantedProsDismissCreateMutationKey = () => ['stafferGigsGrantedProsDismissCreate'] as const;

export const getStafferGigsGrantedProsDismissCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGrantedProsDismissCreate>>, TError,StafferGigsGrantedProsDismissCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGrantedProsDismissCreate>>, TError,StafferGigsGrantedProsDismissCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigsGrantedProsDismissCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsGrantedProsDismissCreate>>, StafferGigsGrantedProsDismissCreateMutationVariables> = (props) => {
          const {gigId,data} = props ?? {};

          return  stafferGigsGrantedProsDismissCreate(gigId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsGrantedProsDismissCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsGrantedProsDismissCreate>>>
    export type StafferGigsGrantedProsDismissCreateMutationBody = GrantedProsDismissRequestRequest
    export type StafferGigsGrantedProsDismissCreateMutationError = void
    export type StafferGigsGrantedProsDismissCreateMutationVariables = {gigId: number;data: GrantedProsDismissRequestRequest}

    export const useStafferGigsGrantedProsDismissCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGrantedProsDismissCreate>>, TError,StafferGigsGrantedProsDismissCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsGrantedProsDismissCreate>>,
        TError,
        StafferGigsGrantedProsDismissCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsGrantedProsDismissCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigsGrantedProsRemindCreateUrl = (gigId: number,) => {




  return `/api/staffer/gigs/${gigId}/granted-pros/remind/`
}

/**
 * Push a SHIFT_INVITE_REMINDER to granted Pros without an application.
 */
export const stafferGigsGrantedProsRemindCreate = async (gigId: number,
    grantedProsRemindRequestRequest: GrantedProsRemindRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<GrantedProsQueuedResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GrantedProsQueuedResponse>(getStafferGigsGrantedProsRemindCreateUrl(gigId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(grantedProsRemindRequestRequest)
  }
);}





export const getStafferGigsGrantedProsRemindCreateMutationKey = () => ['stafferGigsGrantedProsRemindCreate'] as const;

export const getStafferGigsGrantedProsRemindCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGrantedProsRemindCreate>>, TError,StafferGigsGrantedProsRemindCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGrantedProsRemindCreate>>, TError,StafferGigsGrantedProsRemindCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigsGrantedProsRemindCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsGrantedProsRemindCreate>>, StafferGigsGrantedProsRemindCreateMutationVariables> = (props) => {
          const {gigId,data} = props ?? {};

          return  stafferGigsGrantedProsRemindCreate(gigId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsGrantedProsRemindCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsGrantedProsRemindCreate>>>
    export type StafferGigsGrantedProsRemindCreateMutationBody = GrantedProsRemindRequestRequest
    export type StafferGigsGrantedProsRemindCreateMutationError = void
    export type StafferGigsGrantedProsRemindCreateMutationVariables = {gigId: number;data: GrantedProsRemindRequestRequest}

    export const useStafferGigsGrantedProsRemindCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGrantedProsRemindCreate>>, TError,StafferGigsGrantedProsRemindCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsGrantedProsRemindCreate>>,
        TError,
        StafferGigsGrantedProsRemindCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsGrantedProsRemindCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigsRetrieveUrl = (id: number,) => {




  return `/api/staffer/gigs/${id}/`
}

/**
 * Manage gigs as a staffer.
 *
 * This api allowed users to post and manage gigs from a staffer perspective. Note that the format for filtering by
 * start time and end time is ISO 8601, which looks like this: '2020-08-04T18:10:02+00:00'
 */
export const stafferGigsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<StafferGigDetailViewReadonly> => {

  return customFetch<StafferGigDetailViewReadonly>(getStafferGigsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/staffer/gigs/${id}/`
    ] as const;
    }


export const getStafferGigsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsRetrieve>>> = ({ signal }) => stafferGigsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsRetrieve>>>
export type StafferGigsRetrieveQueryError = void


export function useStafferGigsRetrieve<TData = Awaited<ReturnType<typeof stafferGigsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsRetrieve<TData = Awaited<ReturnType<typeof stafferGigsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsRetrieve<TData = Awaited<ReturnType<typeof stafferGigsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsRetrieve<TData = Awaited<ReturnType<typeof stafferGigsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsUpdateUrl = (id: number,) => {




  return `/api/staffer/gigs/${id}/`
}

/**
 * Manage gigs as a staffer.
 *
 * This api allowed users to post and manage gigs from a staffer perspective. Note that the format for filtering by
 * start time and end time is ISO 8601, which looks like this: '2020-08-04T18:10:02+00:00'
 */
export const stafferGigsUpdate = async (id: number,
    stafferGigUpdateRequest: StafferGigUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<StafferGigUpdate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<StafferGigUpdate>(getStafferGigsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(stafferGigUpdateRequest)
  }
);}





export const getStafferGigsUpdateMutationKey = () => ['stafferGigsUpdate'] as const;

export const getStafferGigsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsUpdate>>, TError,StafferGigsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsUpdate>>, TError,StafferGigsUpdateMutationVariables, TContext> => {

const mutationKey = getStafferGigsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsUpdate>>, StafferGigsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  stafferGigsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsUpdate>>>
    export type StafferGigsUpdateMutationBody = StafferGigUpdateRequest
    export type StafferGigsUpdateMutationError = void
    export type StafferGigsUpdateMutationVariables = {id: number;data: StafferGigUpdateRequest}

    export const useStafferGigsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsUpdate>>, TError,StafferGigsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsUpdate>>,
        TError,
        StafferGigsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsUpdateMutationOptions(options), queryClient);
    }
    export const getStafferGigsPartialUpdateUrl = (id: number,
    params?: StafferGigsPartialUpdateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gigs/${id}/?${stringifiedParams}` : `/api/staffer/gigs/${id}/`
}

/**
 * Manage gigs as a staffer.
 *
 * This api allowed users to post and manage gigs from a staffer perspective. Note that the format for filtering by
 * start time and end time is ISO 8601, which looks like this: '2020-08-04T18:10:02+00:00'
 */
export const stafferGigsPartialUpdate = async (id: number,
    patchedStafferGigUpdateRequest?: PatchedStafferGigUpdateRequest,
    params?: StafferGigsPartialUpdateParams, options?: Parameters<typeof customFetch>[1]): Promise<StafferGigUpdate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<StafferGigUpdate>(getStafferGigsPartialUpdateUrl(id,params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedStafferGigUpdateRequest)
  }
);}





export const getStafferGigsPartialUpdateMutationKey = () => ['stafferGigsPartialUpdate'] as const;

export const getStafferGigsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsPartialUpdate>>, TError,StafferGigsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsPartialUpdate>>, TError,StafferGigsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getStafferGigsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsPartialUpdate>>, StafferGigsPartialUpdateMutationVariables> = (props) => {
          const {id,data,params} = props ?? {};

          return  stafferGigsPartialUpdate(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsPartialUpdate>>>
    export type StafferGigsPartialUpdateMutationBody = PatchedStafferGigUpdateRequest | undefined
    export type StafferGigsPartialUpdateMutationError = void
    export type StafferGigsPartialUpdateMutationVariables = {id: number;data?: PatchedStafferGigUpdateRequest;params?: StafferGigsPartialUpdateParams}

    export const useStafferGigsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsPartialUpdate>>, TError,StafferGigsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsPartialUpdate>>,
        TError,
        StafferGigsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getStafferGigsClockCodeRetrieveUrl = (id: number,) => {




  return `/api/staffer/gigs/${id}/clock-code/`
}

/**
 * The gig's current rotating clock code, for the on-site screen.
 */
export const stafferGigsClockCodeRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<GigClockCode> => {

  return customFetch<GigClockCode>(getStafferGigsClockCodeRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsClockCodeRetrieveQueryKey = (id: number,) => {
    return [
    `/api/staffer/gigs/${id}/clock-code/`
    ] as const;
    }


export const getStafferGigsClockCodeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsClockCodeRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsClockCodeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsClockCodeRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsClockCodeRetrieve>>> = ({ signal }) => stafferGigsClockCodeRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsClockCodeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsClockCodeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsClockCodeRetrieve>>>
export type StafferGigsClockCodeRetrieveQueryError = void


export function useStafferGigsClockCodeRetrieve<TData = Awaited<ReturnType<typeof stafferGigsClockCodeRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsClockCodeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsClockCodeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsClockCodeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsClockCodeRetrieve<TData = Awaited<ReturnType<typeof stafferGigsClockCodeRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsClockCodeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsClockCodeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsClockCodeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsClockCodeRetrieve<TData = Awaited<ReturnType<typeof stafferGigsClockCodeRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsClockCodeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsClockCodeRetrieve<TData = Awaited<ReturnType<typeof stafferGigsClockCodeRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsClockCodeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsClockCodeRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsClockKioskCreateUrl = (id: number,) => {




  return `/api/staffer/gigs/${id}/clock-kiosk/`
}

/**
 * A one-time setup link that makes a tablet the venue's clock-in screen, with no manager session on it.
 */
export const stafferGigsClockKioskCreate = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<ClockKioskLink> => {

  return customFetch<ClockKioskLink>(getStafferGigsClockKioskCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStafferGigsClockKioskCreateMutationKey = () => ['stafferGigsClockKioskCreate'] as const;

export const getStafferGigsClockKioskCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsClockKioskCreate>>, TError,StafferGigsClockKioskCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsClockKioskCreate>>, TError,StafferGigsClockKioskCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigsClockKioskCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsClockKioskCreate>>, StafferGigsClockKioskCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  stafferGigsClockKioskCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsClockKioskCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsClockKioskCreate>>>

    export type StafferGigsClockKioskCreateMutationError = void
    export type StafferGigsClockKioskCreateMutationVariables = {id: number}

    export const useStafferGigsClockKioskCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsClockKioskCreate>>, TError,StafferGigsClockKioskCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsClockKioskCreate>>,
        TError,
        StafferGigsClockKioskCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsClockKioskCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigsRecurringPatternRetrieveUrl = (id: number,) => {




  return `/api/staffer/gigs/${id}/recurring-pattern/`
}

/**
 * Returns the recurrence pattern for a recurring gig
 */
export const stafferGigsRecurringPatternRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<RecurringPatternWithTimezone> => {

  return customFetch<RecurringPatternWithTimezone>(getStafferGigsRecurringPatternRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsRecurringPatternRetrieveQueryKey = (id: number,) => {
    return [
    `/api/staffer/gigs/${id}/recurring-pattern/`
    ] as const;
    }


export const getStafferGigsRecurringPatternRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsRecurringPatternRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsRecurringPatternRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsRecurringPatternRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsRecurringPatternRetrieve>>> = ({ signal }) => stafferGigsRecurringPatternRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsRecurringPatternRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsRecurringPatternRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsRecurringPatternRetrieve>>>
export type StafferGigsRecurringPatternRetrieveQueryError = void


export function useStafferGigsRecurringPatternRetrieve<TData = Awaited<ReturnType<typeof stafferGigsRecurringPatternRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsRecurringPatternRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsRecurringPatternRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsRecurringPatternRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsRecurringPatternRetrieve<TData = Awaited<ReturnType<typeof stafferGigsRecurringPatternRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsRecurringPatternRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsRecurringPatternRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsRecurringPatternRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsRecurringPatternRetrieve<TData = Awaited<ReturnType<typeof stafferGigsRecurringPatternRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsRecurringPatternRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsRecurringPatternRetrieve<TData = Awaited<ReturnType<typeof stafferGigsRecurringPatternRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsRecurringPatternRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsRecurringPatternRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsDirectOfferListUrl = (params?: StafferGigsDirectOfferListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gigs/direct-offer/?${stringifiedParams}` : `/api/staffer/gigs/direct-offer/`
}

/**
 * List gigs available to direct-offer to a pro — dedicated path for the legacy
 * ``GET /staffer/gigs/?query=direct_offer`` response. Same data and params, with
 * an accurate per-response serializer in the schema.
 */
export const stafferGigsDirectOfferList = async (params?: StafferGigsDirectOfferListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedGigDirectOfferReadonlyList> => {

  return customFetch<PaginatedGigDirectOfferReadonlyList>(getStafferGigsDirectOfferListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsDirectOfferListInfiniteQueryKey = (params?: StafferGigsDirectOfferListParams,) => {
    return [
    'infinite', `/api/staffer/gigs/direct-offer/`, ...(params ? [params] : [])
    ] as const;
    }

export const getStafferGigsDirectOfferListQueryKey = (params?: StafferGigsDirectOfferListParams,) => {
    return [
    `/api/staffer/gigs/direct-offer/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferGigsDirectOfferListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, StafferGigsDirectOfferListParams['page']>, TError = void>(params?: StafferGigsDirectOfferListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, TError, TData, QueryKey, StafferGigsDirectOfferListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsDirectOfferListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, QueryKey, StafferGigsDirectOfferListParams['page']> = ({ signal, pageParam }) => stafferGigsDirectOfferList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, TError, TData, QueryKey, StafferGigsDirectOfferListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsDirectOfferListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>>
export type StafferGigsDirectOfferListInfiniteQueryError = void


export function useStafferGigsDirectOfferListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, StafferGigsDirectOfferListParams['page']>, TError = void>(
 params: undefined |  StafferGigsDirectOfferListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, TError, TData, QueryKey, StafferGigsDirectOfferListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsDirectOfferList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsDirectOfferListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, StafferGigsDirectOfferListParams['page']>, TError = void>(
 params?: StafferGigsDirectOfferListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, TError, TData, QueryKey, StafferGigsDirectOfferListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsDirectOfferList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsDirectOfferListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, StafferGigsDirectOfferListParams['page']>, TError = void>(
 params?: StafferGigsDirectOfferListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, TError, TData, QueryKey, StafferGigsDirectOfferListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsDirectOfferListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, StafferGigsDirectOfferListParams['page']>, TError = void>(
 params?: StafferGigsDirectOfferListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, TError, TData, QueryKey, StafferGigsDirectOfferListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsDirectOfferListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsDirectOfferListQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, TError = void>(params?: StafferGigsDirectOfferListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsDirectOfferListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>> = ({ signal }) => stafferGigsDirectOfferList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsDirectOfferListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>>
export type StafferGigsDirectOfferListQueryError = void


export function useStafferGigsDirectOfferList<TData = Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, TError = void>(
 params: undefined |  StafferGigsDirectOfferListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsDirectOfferList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsDirectOfferList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsDirectOfferList<TData = Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, TError = void>(
 params?: StafferGigsDirectOfferListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsDirectOfferList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsDirectOfferList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsDirectOfferList<TData = Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, TError = void>(
 params?: StafferGigsDirectOfferListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsDirectOfferList<TData = Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, TError = void>(
 params?: StafferGigsDirectOfferListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsDirectOfferList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsDirectOfferListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsGigManagementListUrl = (params: StafferGigsGigManagementListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gigs/gig-management/?${stringifiedParams}` : `/api/staffer/gigs/gig-management/`
}

/**
 * Endpoint to retrieve records from the GigManagement table.
 */
export const stafferGigsGigManagementList = async (params: StafferGigsGigManagementListParams, options?: Parameters<typeof customFetch>[1]): Promise<GigManagement[]> => {

  return customFetch<GigManagement[]>(getStafferGigsGigManagementListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsGigManagementListQueryKey = (params?: StafferGigsGigManagementListParams,) => {
    return [
    `/api/staffer/gigs/gig-management/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferGigsGigManagementListQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsGigManagementList>>, TError = void>(params: StafferGigsGigManagementListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsGigManagementList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsGigManagementListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsGigManagementList>>> = ({ signal }) => stafferGigsGigManagementList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsGigManagementList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsGigManagementListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsGigManagementList>>>
export type StafferGigsGigManagementListQueryError = void


export function useStafferGigsGigManagementList<TData = Awaited<ReturnType<typeof stafferGigsGigManagementList>>, TError = void>(
 params: StafferGigsGigManagementListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsGigManagementList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsGigManagementList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsGigManagementList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsGigManagementList<TData = Awaited<ReturnType<typeof stafferGigsGigManagementList>>, TError = void>(
 params: StafferGigsGigManagementListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsGigManagementList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsGigManagementList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsGigManagementList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsGigManagementList<TData = Awaited<ReturnType<typeof stafferGigsGigManagementList>>, TError = void>(
 params: StafferGigsGigManagementListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsGigManagementList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsGigManagementList<TData = Awaited<ReturnType<typeof stafferGigsGigManagementList>>, TError = void>(
 params: StafferGigsGigManagementListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsGigManagementList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsGigManagementListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsGigManagementCreateUrl = () => {




  return `/api/staffer/gigs/gig-management/`
}

/**
 * Manage gig management records.
 */
export const stafferGigsGigManagementCreate = async (gigManagementRequest: GigManagementRequest, options?: Parameters<typeof customFetch>[1]): Promise<GigManagement> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GigManagement>(getStafferGigsGigManagementCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(gigManagementRequest)
  }
);}





export const getStafferGigsGigManagementCreateMutationKey = () => ['stafferGigsGigManagementCreate'] as const;

export const getStafferGigsGigManagementCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGigManagementCreate>>, TError,StafferGigsGigManagementCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGigManagementCreate>>, TError,StafferGigsGigManagementCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigsGigManagementCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsGigManagementCreate>>, StafferGigsGigManagementCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  stafferGigsGigManagementCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsGigManagementCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsGigManagementCreate>>>
    export type StafferGigsGigManagementCreateMutationBody = GigManagementRequest
    export type StafferGigsGigManagementCreateMutationError = void
    export type StafferGigsGigManagementCreateMutationVariables = {data: GigManagementRequest}

    export const useStafferGigsGigManagementCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGigManagementCreate>>, TError,StafferGigsGigManagementCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsGigManagementCreate>>,
        TError,
        StafferGigsGigManagementCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsGigManagementCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigsGigManagementPartialUpdateUrl = (id: number,) => {




  return `/api/staffer/gigs/gig-management/${id}/`
}

/**
 * Manage gig management records.
 */
export const stafferGigsGigManagementPartialUpdate = async (id: number,
    patchedGigManagementPartialUpdateRequest?: PatchedGigManagementPartialUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<GigManagementPartialUpdate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GigManagementPartialUpdate>(getStafferGigsGigManagementPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedGigManagementPartialUpdateRequest)
  }
);}





export const getStafferGigsGigManagementPartialUpdateMutationKey = () => ['stafferGigsGigManagementPartialUpdate'] as const;

export const getStafferGigsGigManagementPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGigManagementPartialUpdate>>, TError,StafferGigsGigManagementPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGigManagementPartialUpdate>>, TError,StafferGigsGigManagementPartialUpdateMutationVariables, TContext> => {

const mutationKey = getStafferGigsGigManagementPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsGigManagementPartialUpdate>>, StafferGigsGigManagementPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  stafferGigsGigManagementPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsGigManagementPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsGigManagementPartialUpdate>>>
    export type StafferGigsGigManagementPartialUpdateMutationBody = PatchedGigManagementPartialUpdateRequest | undefined
    export type StafferGigsGigManagementPartialUpdateMutationError = void
    export type StafferGigsGigManagementPartialUpdateMutationVariables = {id: number;data?: PatchedGigManagementPartialUpdateRequest}

    export const useStafferGigsGigManagementPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGigManagementPartialUpdate>>, TError,StafferGigsGigManagementPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsGigManagementPartialUpdate>>,
        TError,
        StafferGigsGigManagementPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsGigManagementPartialUpdateMutationOptions(options), queryClient);
    }
    export const getStafferGigsGigShiftsPartialUpdateUrl = (id: number,) => {




  return `/api/staffer/gigs/gig-shifts/${id}/`
}

export const stafferGigsGigShiftsPartialUpdate = async (id: number,
    patchedGigShiftUpdateRequest?: PatchedGigShiftUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<GigShiftUpdate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GigShiftUpdate>(getStafferGigsGigShiftsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedGigShiftUpdateRequest)
  }
);}





export const getStafferGigsGigShiftsPartialUpdateMutationKey = () => ['stafferGigsGigShiftsPartialUpdate'] as const;

export const getStafferGigsGigShiftsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGigShiftsPartialUpdate>>, TError,StafferGigsGigShiftsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGigShiftsPartialUpdate>>, TError,StafferGigsGigShiftsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getStafferGigsGigShiftsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsGigShiftsPartialUpdate>>, StafferGigsGigShiftsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  stafferGigsGigShiftsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsGigShiftsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsGigShiftsPartialUpdate>>>
    export type StafferGigsGigShiftsPartialUpdateMutationBody = PatchedGigShiftUpdateRequest | undefined
    export type StafferGigsGigShiftsPartialUpdateMutationError = void
    export type StafferGigsGigShiftsPartialUpdateMutationVariables = {id: number;data?: PatchedGigShiftUpdateRequest}

    export const useStafferGigsGigShiftsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsGigShiftsPartialUpdate>>, TError,StafferGigsGigShiftsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsGigShiftsPartialUpdate>>,
        TError,
        StafferGigsGigShiftsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsGigShiftsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getStafferGigsHistoryBySkillListUrl = (params?: StafferGigsHistoryBySkillListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gigs/history-by-skill/?${stringifiedParams}` : `/api/staffer/gigs/history-by-skill/`
}

/**
 * Dedicated path for legacy ``GET /staffer/gigs/?query=history_by_skill`` — same data,
 * accurate per-response serializer in the schema.
 */
export const stafferGigsHistoryBySkillList = async (params?: StafferGigsHistoryBySkillListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedStafferGigHistoryReadonlyList> => {

  return customFetch<PaginatedStafferGigHistoryReadonlyList>(getStafferGigsHistoryBySkillListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsHistoryBySkillListInfiniteQueryKey = (params?: StafferGigsHistoryBySkillListParams,) => {
    return [
    'infinite', `/api/staffer/gigs/history-by-skill/`, ...(params ? [params] : [])
    ] as const;
    }

export const getStafferGigsHistoryBySkillListQueryKey = (params?: StafferGigsHistoryBySkillListParams,) => {
    return [
    `/api/staffer/gigs/history-by-skill/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferGigsHistoryBySkillListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, StafferGigsHistoryBySkillListParams['page']>, TError = void>(params?: StafferGigsHistoryBySkillListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, TError, TData, QueryKey, StafferGigsHistoryBySkillListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsHistoryBySkillListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, QueryKey, StafferGigsHistoryBySkillListParams['page']> = ({ signal, pageParam }) => stafferGigsHistoryBySkillList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, TError, TData, QueryKey, StafferGigsHistoryBySkillListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsHistoryBySkillListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>>
export type StafferGigsHistoryBySkillListInfiniteQueryError = void


export function useStafferGigsHistoryBySkillListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, StafferGigsHistoryBySkillListParams['page']>, TError = void>(
 params: undefined |  StafferGigsHistoryBySkillListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, TError, TData, QueryKey, StafferGigsHistoryBySkillListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsHistoryBySkillListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, StafferGigsHistoryBySkillListParams['page']>, TError = void>(
 params?: StafferGigsHistoryBySkillListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, TError, TData, QueryKey, StafferGigsHistoryBySkillListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsHistoryBySkillListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, StafferGigsHistoryBySkillListParams['page']>, TError = void>(
 params?: StafferGigsHistoryBySkillListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, TError, TData, QueryKey, StafferGigsHistoryBySkillListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsHistoryBySkillListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, StafferGigsHistoryBySkillListParams['page']>, TError = void>(
 params?: StafferGigsHistoryBySkillListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, TError, TData, QueryKey, StafferGigsHistoryBySkillListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsHistoryBySkillListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsHistoryBySkillListQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, TError = void>(params?: StafferGigsHistoryBySkillListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsHistoryBySkillListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>> = ({ signal }) => stafferGigsHistoryBySkillList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsHistoryBySkillListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>>
export type StafferGigsHistoryBySkillListQueryError = void


export function useStafferGigsHistoryBySkillList<TData = Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, TError = void>(
 params: undefined |  StafferGigsHistoryBySkillListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsHistoryBySkillList<TData = Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, TError = void>(
 params?: StafferGigsHistoryBySkillListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsHistoryBySkillList<TData = Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, TError = void>(
 params?: StafferGigsHistoryBySkillListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsHistoryBySkillList<TData = Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, TError = void>(
 params?: StafferGigsHistoryBySkillListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsHistoryBySkillList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsHistoryBySkillListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsTemplatesListUrl = (params?: StafferGigsTemplatesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gigs/templates/?${stringifiedParams}` : `/api/staffer/gigs/templates/`
}

export const stafferGigsTemplatesList = async (params?: StafferGigsTemplatesListParams, options?: Parameters<typeof customFetch>[1]): Promise<GigShiftTemplateReadonly[]> => {

  return customFetch<GigShiftTemplateReadonly[]>(getStafferGigsTemplatesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsTemplatesListQueryKey = (params?: StafferGigsTemplatesListParams,) => {
    return [
    `/api/staffer/gigs/templates/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferGigsTemplatesListQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsTemplatesList>>, TError = void>(params?: StafferGigsTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsTemplatesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsTemplatesList>>> = ({ signal }) => stafferGigsTemplatesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsTemplatesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsTemplatesListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsTemplatesList>>>
export type StafferGigsTemplatesListQueryError = void


export function useStafferGigsTemplatesList<TData = Awaited<ReturnType<typeof stafferGigsTemplatesList>>, TError = void>(
 params: undefined |  StafferGigsTemplatesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsTemplatesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsTemplatesList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsTemplatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsTemplatesList<TData = Awaited<ReturnType<typeof stafferGigsTemplatesList>>, TError = void>(
 params?: StafferGigsTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsTemplatesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsTemplatesList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsTemplatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsTemplatesList<TData = Awaited<ReturnType<typeof stafferGigsTemplatesList>>, TError = void>(
 params?: StafferGigsTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsTemplatesList<TData = Awaited<ReturnType<typeof stafferGigsTemplatesList>>, TError = void>(
 params?: StafferGigsTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsTemplatesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsTemplatesCreateUrl = () => {




  return `/api/staffer/gigs/templates/`
}

export const stafferGigsTemplatesCreate = async (gigShiftTemplateRequest: GigShiftTemplateRequest, options?: Parameters<typeof customFetch>[1]): Promise<GigShiftTemplate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GigShiftTemplate>(getStafferGigsTemplatesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(gigShiftTemplateRequest)
  }
);}





export const getStafferGigsTemplatesCreateMutationKey = () => ['stafferGigsTemplatesCreate'] as const;

export const getStafferGigsTemplatesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsTemplatesCreate>>, TError,StafferGigsTemplatesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsTemplatesCreate>>, TError,StafferGigsTemplatesCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigsTemplatesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsTemplatesCreate>>, StafferGigsTemplatesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  stafferGigsTemplatesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsTemplatesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsTemplatesCreate>>>
    export type StafferGigsTemplatesCreateMutationBody = GigShiftTemplateRequest
    export type StafferGigsTemplatesCreateMutationError = void
    export type StafferGigsTemplatesCreateMutationVariables = {data: GigShiftTemplateRequest}

    export const useStafferGigsTemplatesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsTemplatesCreate>>, TError,StafferGigsTemplatesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsTemplatesCreate>>,
        TError,
        StafferGigsTemplatesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsTemplatesCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigsTemplatesRetrieveUrl = (id: number,) => {




  return `/api/staffer/gigs/templates/${id}/`
}

export const stafferGigsTemplatesRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<GigShiftTemplateReadonly> => {

  return customFetch<GigShiftTemplateReadonly>(getStafferGigsTemplatesRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsTemplatesRetrieveQueryKey = (id: number,) => {
    return [
    `/api/staffer/gigs/templates/${id}/`
    ] as const;
    }


export const getStafferGigsTemplatesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsTemplatesRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsTemplatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsTemplatesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsTemplatesRetrieve>>> = ({ signal }) => stafferGigsTemplatesRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsTemplatesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsTemplatesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsTemplatesRetrieve>>>
export type StafferGigsTemplatesRetrieveQueryError = void


export function useStafferGigsTemplatesRetrieve<TData = Awaited<ReturnType<typeof stafferGigsTemplatesRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsTemplatesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsTemplatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsTemplatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsTemplatesRetrieve<TData = Awaited<ReturnType<typeof stafferGigsTemplatesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsTemplatesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsTemplatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsTemplatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsTemplatesRetrieve<TData = Awaited<ReturnType<typeof stafferGigsTemplatesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsTemplatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsTemplatesRetrieve<TData = Awaited<ReturnType<typeof stafferGigsTemplatesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsTemplatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsTemplatesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsTemplatesUpdateUrl = (id: number,) => {




  return `/api/staffer/gigs/templates/${id}/`
}

export const stafferGigsTemplatesUpdate = async (id: number,
    gigShiftTemplateRequest: GigShiftTemplateRequest, options?: Parameters<typeof customFetch>[1]): Promise<GigShiftTemplate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GigShiftTemplate>(getStafferGigsTemplatesUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(gigShiftTemplateRequest)
  }
);}





export const getStafferGigsTemplatesUpdateMutationKey = () => ['stafferGigsTemplatesUpdate'] as const;

export const getStafferGigsTemplatesUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsTemplatesUpdate>>, TError,StafferGigsTemplatesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsTemplatesUpdate>>, TError,StafferGigsTemplatesUpdateMutationVariables, TContext> => {

const mutationKey = getStafferGigsTemplatesUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsTemplatesUpdate>>, StafferGigsTemplatesUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  stafferGigsTemplatesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsTemplatesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsTemplatesUpdate>>>
    export type StafferGigsTemplatesUpdateMutationBody = GigShiftTemplateRequest
    export type StafferGigsTemplatesUpdateMutationError = void
    export type StafferGigsTemplatesUpdateMutationVariables = {id: number;data: GigShiftTemplateRequest}

    export const useStafferGigsTemplatesUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsTemplatesUpdate>>, TError,StafferGigsTemplatesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsTemplatesUpdate>>,
        TError,
        StafferGigsTemplatesUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsTemplatesUpdateMutationOptions(options), queryClient);
    }
    export const getStafferGigsTemplatesPartialUpdateUrl = (id: number,) => {




  return `/api/staffer/gigs/templates/${id}/`
}

export const stafferGigsTemplatesPartialUpdate = async (id: number,
    patchedGigShiftTemplateRequest?: PatchedGigShiftTemplateRequest, options?: Parameters<typeof customFetch>[1]): Promise<GigShiftTemplate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GigShiftTemplate>(getStafferGigsTemplatesPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedGigShiftTemplateRequest)
  }
);}





export const getStafferGigsTemplatesPartialUpdateMutationKey = () => ['stafferGigsTemplatesPartialUpdate'] as const;

export const getStafferGigsTemplatesPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsTemplatesPartialUpdate>>, TError,StafferGigsTemplatesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsTemplatesPartialUpdate>>, TError,StafferGigsTemplatesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getStafferGigsTemplatesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsTemplatesPartialUpdate>>, StafferGigsTemplatesPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  stafferGigsTemplatesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsTemplatesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsTemplatesPartialUpdate>>>
    export type StafferGigsTemplatesPartialUpdateMutationBody = PatchedGigShiftTemplateRequest | undefined
    export type StafferGigsTemplatesPartialUpdateMutationError = void
    export type StafferGigsTemplatesPartialUpdateMutationVariables = {id: number;data?: PatchedGigShiftTemplateRequest}

    export const useStafferGigsTemplatesPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsTemplatesPartialUpdate>>, TError,StafferGigsTemplatesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsTemplatesPartialUpdate>>,
        TError,
        StafferGigsTemplatesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsTemplatesPartialUpdateMutationOptions(options), queryClient);
    }
    export const getStafferGigsTemplatesDestroyUrl = (id: number,) => {




  return `/api/staffer/gigs/templates/${id}/`
}

export const stafferGigsTemplatesDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getStafferGigsTemplatesDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getStafferGigsTemplatesDestroyMutationKey = () => ['stafferGigsTemplatesDestroy'] as const;

export const getStafferGigsTemplatesDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsTemplatesDestroy>>, TError,StafferGigsTemplatesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsTemplatesDestroy>>, TError,StafferGigsTemplatesDestroyMutationVariables, TContext> => {

const mutationKey = getStafferGigsTemplatesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsTemplatesDestroy>>, StafferGigsTemplatesDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  stafferGigsTemplatesDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsTemplatesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsTemplatesDestroy>>>

    export type StafferGigsTemplatesDestroyMutationError = void
    export type StafferGigsTemplatesDestroyMutationVariables = {id: number}

    export const useStafferGigsTemplatesDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsTemplatesDestroy>>, TError,StafferGigsTemplatesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsTemplatesDestroy>>,
        TError,
        StafferGigsTemplatesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsTemplatesDestroyMutationOptions(options), queryClient);
    }
    export const getStafferGigsV2ListUrl = (params?: StafferGigsV2ListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gigs/v2/?${stringifiedParams}` : `/api/staffer/gigs/v2/`
}

/**
 * Manage gigs as a staffer.
 *
 * This api allowed users to post and manage gigs from a staffer perspective. Note that the format for filtering by
 * start time and end time is ISO 8601, which looks like this: '2020-08-04T18:10:02+00:00'
 */
export const stafferGigsV2List = async (params?: StafferGigsV2ListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedStafferGigViewReadonlySerializerV2List> => {

  return customFetch<PaginatedStafferGigViewReadonlySerializerV2List>(getStafferGigsV2ListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsV2ListInfiniteQueryKey = (params?: StafferGigsV2ListParams,) => {
    return [
    'infinite', `/api/staffer/gigs/v2/`, ...(params ? [params] : [])
    ] as const;
    }

export const getStafferGigsV2ListQueryKey = (params?: StafferGigsV2ListParams,) => {
    return [
    `/api/staffer/gigs/v2/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferGigsV2ListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsV2List>>, StafferGigsV2ListParams['page']>, TError = void>(params?: StafferGigsV2ListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsV2List>>, TError, TData, QueryKey, StafferGigsV2ListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsV2ListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsV2List>>, QueryKey, StafferGigsV2ListParams['page']> = ({ signal, pageParam }) => stafferGigsV2List({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsV2List>>, TError, TData, QueryKey, StafferGigsV2ListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsV2ListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsV2List>>>
export type StafferGigsV2ListInfiniteQueryError = void


export function useStafferGigsV2ListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsV2List>>, StafferGigsV2ListParams['page']>, TError = void>(
 params: undefined |  StafferGigsV2ListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsV2List>>, TError, TData, QueryKey, StafferGigsV2ListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsV2List>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsV2List>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsV2ListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsV2List>>, StafferGigsV2ListParams['page']>, TError = void>(
 params?: StafferGigsV2ListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsV2List>>, TError, TData, QueryKey, StafferGigsV2ListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsV2List>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsV2List>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsV2ListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsV2List>>, StafferGigsV2ListParams['page']>, TError = void>(
 params?: StafferGigsV2ListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsV2List>>, TError, TData, QueryKey, StafferGigsV2ListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsV2ListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsV2List>>, StafferGigsV2ListParams['page']>, TError = void>(
 params?: StafferGigsV2ListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsV2List>>, TError, TData, QueryKey, StafferGigsV2ListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsV2ListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsV2ListQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsV2List>>, TError = void>(params?: StafferGigsV2ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2List>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsV2ListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsV2List>>> = ({ signal }) => stafferGigsV2List(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2List>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsV2ListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsV2List>>>
export type StafferGigsV2ListQueryError = void


export function useStafferGigsV2List<TData = Awaited<ReturnType<typeof stafferGigsV2List>>, TError = void>(
 params: undefined |  StafferGigsV2ListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2List>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsV2List>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsV2List>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsV2List<TData = Awaited<ReturnType<typeof stafferGigsV2List>>, TError = void>(
 params?: StafferGigsV2ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2List>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsV2List>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsV2List>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsV2List<TData = Awaited<ReturnType<typeof stafferGigsV2List>>, TError = void>(
 params?: StafferGigsV2ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2List>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsV2List<TData = Awaited<ReturnType<typeof stafferGigsV2List>>, TError = void>(
 params?: StafferGigsV2ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2List>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsV2ListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsV2CreateUrl = (params?: StafferGigsV2CreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gigs/v2/?${stringifiedParams}` : `/api/staffer/gigs/v2/`
}

/**
 * Manage gigs as a staffer.
 *
 * This api allowed users to post and manage gigs from a staffer perspective. Note that the format for filtering by
 * start time and end time is ISO 8601, which looks like this: '2020-08-04T18:10:02+00:00'
 */
export const stafferGigsV2Create = async (stafferGigCreateRequest: StafferGigCreateRequest,
    params?: StafferGigsV2CreateParams, options?: Parameters<typeof customFetch>[1]): Promise<void | StafferGigCreate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<void | StafferGigCreate>(getStafferGigsV2CreateUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(stafferGigCreateRequest)
  }
);}





export const getStafferGigsV2CreateMutationKey = () => ['stafferGigsV2Create'] as const;

export const getStafferGigsV2CreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2Create>>, TError,StafferGigsV2CreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2Create>>, TError,StafferGigsV2CreateMutationVariables, TContext> => {

const mutationKey = getStafferGigsV2CreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsV2Create>>, StafferGigsV2CreateMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  stafferGigsV2Create(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsV2CreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsV2Create>>>
    export type StafferGigsV2CreateMutationBody = StafferGigCreateRequest
    export type StafferGigsV2CreateMutationError = void
    export type StafferGigsV2CreateMutationVariables = {data: StafferGigCreateRequest;params?: StafferGigsV2CreateParams}

    export const useStafferGigsV2Create = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2Create>>, TError,StafferGigsV2CreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsV2Create>>,
        TError,
        StafferGigsV2CreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsV2CreateMutationOptions(options), queryClient);
    }
    export const getStafferGigsV2RetrieveUrl = (id: number,) => {




  return `/api/staffer/gigs/v2/${id}/`
}

/**
 * Manage gigs as a staffer.
 *
 * This api allowed users to post and manage gigs from a staffer perspective. Note that the format for filtering by
 * start time and end time is ISO 8601, which looks like this: '2020-08-04T18:10:02+00:00'
 */
export const stafferGigsV2Retrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<StafferGigViewReadonlyRetrieveSerializerV2> => {

  return customFetch<StafferGigViewReadonlyRetrieveSerializerV2>(getStafferGigsV2RetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsV2RetrieveQueryKey = (id: number,) => {
    return [
    `/api/staffer/gigs/v2/${id}/`
    ] as const;
    }


export const getStafferGigsV2RetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsV2Retrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsV2RetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsV2Retrieve>>> = ({ signal }) => stafferGigsV2Retrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2Retrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsV2RetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsV2Retrieve>>>
export type StafferGigsV2RetrieveQueryError = void


export function useStafferGigsV2Retrieve<TData = Awaited<ReturnType<typeof stafferGigsV2Retrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2Retrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsV2Retrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsV2Retrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsV2Retrieve<TData = Awaited<ReturnType<typeof stafferGigsV2Retrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2Retrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsV2Retrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsV2Retrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsV2Retrieve<TData = Awaited<ReturnType<typeof stafferGigsV2Retrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsV2Retrieve<TData = Awaited<ReturnType<typeof stafferGigsV2Retrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsV2RetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsV2UpdateUrl = (id: number,) => {




  return `/api/staffer/gigs/v2/${id}/`
}

/**
 * Manage gigs as a staffer.
 *
 * This api allowed users to post and manage gigs from a staffer perspective. Note that the format for filtering by
 * start time and end time is ISO 8601, which looks like this: '2020-08-04T18:10:02+00:00'
 */
export const stafferGigsV2Update = async (id: number,
    stafferGigUpdateRequest: StafferGigUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<StafferGigUpdate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<StafferGigUpdate>(getStafferGigsV2UpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(stafferGigUpdateRequest)
  }
);}





export const getStafferGigsV2UpdateMutationKey = () => ['stafferGigsV2Update'] as const;

export const getStafferGigsV2UpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2Update>>, TError,StafferGigsV2UpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2Update>>, TError,StafferGigsV2UpdateMutationVariables, TContext> => {

const mutationKey = getStafferGigsV2UpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsV2Update>>, StafferGigsV2UpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  stafferGigsV2Update(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsV2UpdateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsV2Update>>>
    export type StafferGigsV2UpdateMutationBody = StafferGigUpdateRequest
    export type StafferGigsV2UpdateMutationError = void
    export type StafferGigsV2UpdateMutationVariables = {id: number;data: StafferGigUpdateRequest}

    export const useStafferGigsV2Update = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2Update>>, TError,StafferGigsV2UpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsV2Update>>,
        TError,
        StafferGigsV2UpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsV2UpdateMutationOptions(options), queryClient);
    }
    export const getStafferGigsV2PartialUpdateUrl = (id: number,
    params?: StafferGigsV2PartialUpdateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gigs/v2/${id}/?${stringifiedParams}` : `/api/staffer/gigs/v2/${id}/`
}

/**
 * Manage gigs as a staffer.
 *
 * This api allowed users to post and manage gigs from a staffer perspective. Note that the format for filtering by
 * start time and end time is ISO 8601, which looks like this: '2020-08-04T18:10:02+00:00'
 */
export const stafferGigsV2PartialUpdate = async (id: number,
    patchedStafferGigUpdateRequest?: PatchedStafferGigUpdateRequest,
    params?: StafferGigsV2PartialUpdateParams, options?: Parameters<typeof customFetch>[1]): Promise<StafferGigUpdate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<StafferGigUpdate>(getStafferGigsV2PartialUpdateUrl(id,params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedStafferGigUpdateRequest)
  }
);}





export const getStafferGigsV2PartialUpdateMutationKey = () => ['stafferGigsV2PartialUpdate'] as const;

export const getStafferGigsV2PartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2PartialUpdate>>, TError,StafferGigsV2PartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2PartialUpdate>>, TError,StafferGigsV2PartialUpdateMutationVariables, TContext> => {

const mutationKey = getStafferGigsV2PartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsV2PartialUpdate>>, StafferGigsV2PartialUpdateMutationVariables> = (props) => {
          const {id,data,params} = props ?? {};

          return  stafferGigsV2PartialUpdate(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsV2PartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsV2PartialUpdate>>>
    export type StafferGigsV2PartialUpdateMutationBody = PatchedStafferGigUpdateRequest | undefined
    export type StafferGigsV2PartialUpdateMutationError = void
    export type StafferGigsV2PartialUpdateMutationVariables = {id: number;data?: PatchedStafferGigUpdateRequest;params?: StafferGigsV2PartialUpdateParams}

    export const useStafferGigsV2PartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2PartialUpdate>>, TError,StafferGigsV2PartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsV2PartialUpdate>>,
        TError,
        StafferGigsV2PartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsV2PartialUpdateMutationOptions(options), queryClient);
    }
    export const getStafferGigsV2CloseShiftCreateUrl = (id: number,) => {




  return `/api/staffer/gigs/v2/${id}/close-shift/`
}

/**
 * Close a shift now, or schedule it to close later. Without scheduled_shift_close_time, or with a time at or before now, the shift is closed before the response returns and shift_closed_time is set. A future time is stored and a periodic task closes the shift within 5 minutes of it. Returns 400 if the shift is already closed, cancelled or ended, if the time is less than 5 minutes from now, or if it is after the shift's start.
 */
export const stafferGigsV2CloseShiftCreate = async (id: number,
    stafferGigCloseShiftRequest?: StafferGigCloseShiftRequest, options?: Parameters<typeof customFetch>[1]): Promise<StafferGigCloseShift> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<StafferGigCloseShift>(getStafferGigsV2CloseShiftCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(stafferGigCloseShiftRequest)
  }
);}





export const getStafferGigsV2CloseShiftCreateMutationKey = () => ['stafferGigsV2CloseShiftCreate'] as const;

export const getStafferGigsV2CloseShiftCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2CloseShiftCreate>>, TError,StafferGigsV2CloseShiftCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2CloseShiftCreate>>, TError,StafferGigsV2CloseShiftCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigsV2CloseShiftCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsV2CloseShiftCreate>>, StafferGigsV2CloseShiftCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  stafferGigsV2CloseShiftCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsV2CloseShiftCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsV2CloseShiftCreate>>>
    export type StafferGigsV2CloseShiftCreateMutationBody = StafferGigCloseShiftRequest | undefined
    export type StafferGigsV2CloseShiftCreateMutationError = void
    export type StafferGigsV2CloseShiftCreateMutationVariables = {id: number;data?: StafferGigCloseShiftRequest}

    export const useStafferGigsV2CloseShiftCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2CloseShiftCreate>>, TError,StafferGigsV2CloseShiftCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsV2CloseShiftCreate>>,
        TError,
        StafferGigsV2CloseShiftCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsV2CloseShiftCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigsV2RecurringPatternRetrieveUrl = (id: number,) => {




  return `/api/staffer/gigs/v2/${id}/recurring-pattern/`
}

/**
 * Returns the recurrence pattern for a recurring gig
 */
export const stafferGigsV2RecurringPatternRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<RecurringPatternWithTimezone> => {

  return customFetch<RecurringPatternWithTimezone>(getStafferGigsV2RecurringPatternRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsV2RecurringPatternRetrieveQueryKey = (id: number,) => {
    return [
    `/api/staffer/gigs/v2/${id}/recurring-pattern/`
    ] as const;
    }


export const getStafferGigsV2RecurringPatternRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsV2RecurringPatternRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsV2RecurringPatternRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternRetrieve>>> = ({ signal }) => stafferGigsV2RecurringPatternRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsV2RecurringPatternRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternRetrieve>>>
export type StafferGigsV2RecurringPatternRetrieveQueryError = void


export function useStafferGigsV2RecurringPatternRetrieve<TData = Awaited<ReturnType<typeof stafferGigsV2RecurringPatternRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsV2RecurringPatternRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsV2RecurringPatternRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsV2RecurringPatternRetrieve<TData = Awaited<ReturnType<typeof stafferGigsV2RecurringPatternRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsV2RecurringPatternRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsV2RecurringPatternRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsV2RecurringPatternRetrieve<TData = Awaited<ReturnType<typeof stafferGigsV2RecurringPatternRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsV2RecurringPatternRetrieve<TData = Awaited<ReturnType<typeof stafferGigsV2RecurringPatternRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsV2RecurringPatternRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsV2BulkSettingsPartialUpdateUrl = () => {




  return `/api/staffer/gigs/v2/bulk-settings/`
}

/**
 * Apply a settings toggle to many shifts in one request. Iteration 0 sets auto_select_enabled (autopilot) on every gig in gig_ids. Scoped to shifts the requester manages and validated all-or-nothing: if any id is unmanaged/nonexistent or names a gig that does not support auto-select, the whole request is rejected (400, offending ids listed) with no partial write. Each gig is routed through the same GigService.update SETTINGS path the single-gig PATCH uses, so validation and side-effects are identical. The location standing default (Location.immediate_auto_select_enabled) is not touched.
 */
export const stafferGigsV2BulkSettingsPartialUpdate = async (patchedStafferGigBulkSettingsRequest?: PatchedStafferGigBulkSettingsRequest, options?: Parameters<typeof customFetch>[1]): Promise<StafferGigBulkSettingsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<StafferGigBulkSettingsResponse>(getStafferGigsV2BulkSettingsPartialUpdateUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedStafferGigBulkSettingsRequest)
  }
);}





export const getStafferGigsV2BulkSettingsPartialUpdateMutationKey = () => ['stafferGigsV2BulkSettingsPartialUpdate'] as const;

export const getStafferGigsV2BulkSettingsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2BulkSettingsPartialUpdate>>, TError,StafferGigsV2BulkSettingsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2BulkSettingsPartialUpdate>>, TError,StafferGigsV2BulkSettingsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getStafferGigsV2BulkSettingsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsV2BulkSettingsPartialUpdate>>, StafferGigsV2BulkSettingsPartialUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  stafferGigsV2BulkSettingsPartialUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsV2BulkSettingsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsV2BulkSettingsPartialUpdate>>>
    export type StafferGigsV2BulkSettingsPartialUpdateMutationBody = PatchedStafferGigBulkSettingsRequest | undefined
    export type StafferGigsV2BulkSettingsPartialUpdateMutationError = void
    export type StafferGigsV2BulkSettingsPartialUpdateMutationVariables = {data?: PatchedStafferGigBulkSettingsRequest}

    export const useStafferGigsV2BulkSettingsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2BulkSettingsPartialUpdate>>, TError,StafferGigsV2BulkSettingsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsV2BulkSettingsPartialUpdate>>,
        TError,
        StafferGigsV2BulkSettingsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsV2BulkSettingsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getStafferGigsV2CalendarListUrl = (params: StafferGigsV2CalendarListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gigs/v2/calendar/?${stringifiedParams}` : `/api/staffer/gigs/v2/calendar/`
}

/**
 * Returns a list of gigs with simplified details since the new calendar view
 * will show a lot more gigs than our current schedule page. The detailed view of the gig
 * will be fetched on demand when the user clicks on the gig.
 *
 * Requires at least one of ``organization_id`` (org-wide across the requester's managed
 * locations) or ``location_id`` (single location). Passing neither returns 400 — this
 * guardrail prevents an admin from omitting both and pulling every gig in the system.
 * ``scope_gigs`` still bounds results to the locations the requester manages, so there is
 * no cross-org leak even when ``organization_id`` is supplied.
 */
export const stafferGigsV2CalendarList = async (params: StafferGigsV2CalendarListParams, options?: Parameters<typeof customFetch>[1]): Promise<StafferGigViewReadonlySerializerV3[]> => {

  return customFetch<StafferGigViewReadonlySerializerV3[]>(getStafferGigsV2CalendarListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsV2CalendarListQueryKey = (params?: StafferGigsV2CalendarListParams,) => {
    return [
    `/api/staffer/gigs/v2/calendar/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferGigsV2CalendarListQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsV2CalendarList>>, TError = void>(params: StafferGigsV2CalendarListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2CalendarList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsV2CalendarListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsV2CalendarList>>> = ({ signal }) => stafferGigsV2CalendarList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2CalendarList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsV2CalendarListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsV2CalendarList>>>
export type StafferGigsV2CalendarListQueryError = void


export function useStafferGigsV2CalendarList<TData = Awaited<ReturnType<typeof stafferGigsV2CalendarList>>, TError = void>(
 params: StafferGigsV2CalendarListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2CalendarList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsV2CalendarList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsV2CalendarList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsV2CalendarList<TData = Awaited<ReturnType<typeof stafferGigsV2CalendarList>>, TError = void>(
 params: StafferGigsV2CalendarListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2CalendarList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsV2CalendarList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsV2CalendarList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsV2CalendarList<TData = Awaited<ReturnType<typeof stafferGigsV2CalendarList>>, TError = void>(
 params: StafferGigsV2CalendarListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2CalendarList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsV2CalendarList<TData = Awaited<ReturnType<typeof stafferGigsV2CalendarList>>, TError = void>(
 params: StafferGigsV2CalendarListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2CalendarList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsV2CalendarListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsV2RecurringPatternDatesCreateUrl = () => {




  return `/api/staffer/gigs/v2/recurring-pattern/dates/`
}

/**
 * Returns a list of dates based on the provided recurring pattern
 */
export const stafferGigsV2RecurringPatternDatesCreate = async (recurringPatternPreviewQueryRequest: RecurringPatternPreviewQueryRequest, options?: Parameters<typeof customFetch>[1]): Promise<RecurringPatternPreviewList> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<RecurringPatternPreviewList>(getStafferGigsV2RecurringPatternDatesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(recurringPatternPreviewQueryRequest)
  }
);}





export const getStafferGigsV2RecurringPatternDatesCreateMutationKey = () => ['stafferGigsV2RecurringPatternDatesCreate'] as const;

export const getStafferGigsV2RecurringPatternDatesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternDatesCreate>>, TError,StafferGigsV2RecurringPatternDatesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternDatesCreate>>, TError,StafferGigsV2RecurringPatternDatesCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigsV2RecurringPatternDatesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternDatesCreate>>, StafferGigsV2RecurringPatternDatesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  stafferGigsV2RecurringPatternDatesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsV2RecurringPatternDatesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternDatesCreate>>>
    export type StafferGigsV2RecurringPatternDatesCreateMutationBody = RecurringPatternPreviewQueryRequest
    export type StafferGigsV2RecurringPatternDatesCreateMutationError = void
    export type StafferGigsV2RecurringPatternDatesCreateMutationVariables = {data: RecurringPatternPreviewQueryRequest}

    export const useStafferGigsV2RecurringPatternDatesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternDatesCreate>>, TError,StafferGigsV2RecurringPatternDatesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsV2RecurringPatternDatesCreate>>,
        TError,
        StafferGigsV2RecurringPatternDatesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsV2RecurringPatternDatesCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigsV2RecurringPatternGigsListUrl = (params: StafferGigsV2RecurringPatternGigsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gigs/v2/recurring-pattern/gigs/?${stringifiedParams}` : `/api/staffer/gigs/v2/recurring-pattern/gigs/`
}

/**
 * Returns a list of future recurring gigs based on all the recurring patterns of the location
 */
export const stafferGigsV2RecurringPatternGigsList = async (params: StafferGigsV2RecurringPatternGigsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PreviewRecurringGig[]> => {

  return customFetch<PreviewRecurringGig[]>(getStafferGigsV2RecurringPatternGigsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsV2RecurringPatternGigsListQueryKey = (params?: StafferGigsV2RecurringPatternGigsListParams,) => {
    return [
    `/api/staffer/gigs/v2/recurring-pattern/gigs/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferGigsV2RecurringPatternGigsListQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsV2RecurringPatternGigsList>>, TError = void>(params: StafferGigsV2RecurringPatternGigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternGigsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsV2RecurringPatternGigsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternGigsList>>> = ({ signal }) => stafferGigsV2RecurringPatternGigsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternGigsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsV2RecurringPatternGigsListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternGigsList>>>
export type StafferGigsV2RecurringPatternGigsListQueryError = void


export function useStafferGigsV2RecurringPatternGigsList<TData = Awaited<ReturnType<typeof stafferGigsV2RecurringPatternGigsList>>, TError = void>(
 params: StafferGigsV2RecurringPatternGigsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternGigsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsV2RecurringPatternGigsList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsV2RecurringPatternGigsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsV2RecurringPatternGigsList<TData = Awaited<ReturnType<typeof stafferGigsV2RecurringPatternGigsList>>, TError = void>(
 params: StafferGigsV2RecurringPatternGigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternGigsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsV2RecurringPatternGigsList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsV2RecurringPatternGigsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsV2RecurringPatternGigsList<TData = Awaited<ReturnType<typeof stafferGigsV2RecurringPatternGigsList>>, TError = void>(
 params: StafferGigsV2RecurringPatternGigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternGigsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsV2RecurringPatternGigsList<TData = Awaited<ReturnType<typeof stafferGigsV2RecurringPatternGigsList>>, TError = void>(
 params: StafferGigsV2RecurringPatternGigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsV2RecurringPatternGigsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsV2RecurringPatternGigsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsterProfilesListUrl = (params: StafferGigsterProfilesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gigster-profiles/?${stringifiedParams}` : `/api/staffer/gigster-profiles/`
}

/**
 * Standard DRF list flow with the HD chip attached on the paginated page.
 *
 * ``annotate_high_demand`` was previously called in ``filter_queryset``,
 * which forced a ``values_list().distinct()`` over the unpaginated
 * market-wide pro pool and rode a large ``id__in`` ``Case`` through the
 * paginated SELECT — on big markets (Westmont / Bon Appetit) the toggle
 * being on made the Pros tab time out. Resolving ``_is_high_demand`` on
 * the ~20 instances actually returned to the client keeps the predicate
 * cost bounded by page size. Tradeoff: cannot sort / filter by the chip
 * without re-introducing a pre-pagination annotation, which we don't do
 * today.
 */
export const stafferGigsterProfilesList = async (params: StafferGigsterProfilesListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedFilteredGigsterReadOnlyList> => {

  return customFetch<PaginatedFilteredGigsterReadOnlyList>(getStafferGigsterProfilesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsterProfilesListInfiniteQueryKey = (params?: StafferGigsterProfilesListParams,) => {
    return [
    'infinite', `/api/staffer/gigster-profiles/`, ...(params ? [params] : [])
    ] as const;
    }

export const getStafferGigsterProfilesListQueryKey = (params?: StafferGigsterProfilesListParams,) => {
    return [
    `/api/staffer/gigster-profiles/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferGigsterProfilesListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, StafferGigsterProfilesListParams['page']>, TError = void>(params: StafferGigsterProfilesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, TError, TData, QueryKey, StafferGigsterProfilesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsterProfilesListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, QueryKey, StafferGigsterProfilesListParams['page']> = ({ signal, pageParam }) => stafferGigsterProfilesList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, TError, TData, QueryKey, StafferGigsterProfilesListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsterProfilesListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsterProfilesList>>>
export type StafferGigsterProfilesListInfiniteQueryError = void


export function useStafferGigsterProfilesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, StafferGigsterProfilesListParams['page']>, TError = void>(
 params: StafferGigsterProfilesListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, TError, TData, QueryKey, StafferGigsterProfilesListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsterProfilesList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsterProfilesList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsterProfilesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, StafferGigsterProfilesListParams['page']>, TError = void>(
 params: StafferGigsterProfilesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, TError, TData, QueryKey, StafferGigsterProfilesListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsterProfilesList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsterProfilesList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsterProfilesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, StafferGigsterProfilesListParams['page']>, TError = void>(
 params: StafferGigsterProfilesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, TError, TData, QueryKey, StafferGigsterProfilesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsterProfilesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, StafferGigsterProfilesListParams['page']>, TError = void>(
 params: StafferGigsterProfilesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, TError, TData, QueryKey, StafferGigsterProfilesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsterProfilesListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsterProfilesListQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsterProfilesList>>, TError = void>(params: StafferGigsterProfilesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsterProfilesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsterProfilesList>>> = ({ signal }) => stafferGigsterProfilesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsterProfilesListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsterProfilesList>>>
export type StafferGigsterProfilesListQueryError = void


export function useStafferGigsterProfilesList<TData = Awaited<ReturnType<typeof stafferGigsterProfilesList>>, TError = void>(
 params: StafferGigsterProfilesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsterProfilesList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsterProfilesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsterProfilesList<TData = Awaited<ReturnType<typeof stafferGigsterProfilesList>>, TError = void>(
 params: StafferGigsterProfilesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsterProfilesList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsterProfilesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsterProfilesList<TData = Awaited<ReturnType<typeof stafferGigsterProfilesList>>, TError = void>(
 params: StafferGigsterProfilesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsterProfilesList<TData = Awaited<ReturnType<typeof stafferGigsterProfilesList>>, TError = void>(
 params: StafferGigsterProfilesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsterProfilesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsterProfilesRetrieveUrl = (id: number,) => {




  return `/api/staffer/gigster-profiles/${id}/`
}

/**
 * This API is designed for managers to retrieve a filtered list of Pro profiles,
 * it has a couple of implied/default filters which are:
 * - has worked here
 * - exclude selected, confirmed or cancelled applications from the given gig
 */
export const stafferGigsterProfilesRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<GigsterProfileExtendedReadonly> => {

  return customFetch<GigsterProfileExtendedReadonly>(getStafferGigsterProfilesRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsterProfilesRetrieveQueryKey = (id: number,) => {
    return [
    `/api/staffer/gigster-profiles/${id}/`
    ] as const;
    }


export const getStafferGigsterProfilesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsterProfilesRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsterProfilesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsterProfilesRetrieve>>> = ({ signal }) => stafferGigsterProfilesRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsterProfilesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsterProfilesRetrieve>>>
export type StafferGigsterProfilesRetrieveQueryError = void


export function useStafferGigsterProfilesRetrieve<TData = Awaited<ReturnType<typeof stafferGigsterProfilesRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsterProfilesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsterProfilesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsterProfilesRetrieve<TData = Awaited<ReturnType<typeof stafferGigsterProfilesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsterProfilesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsterProfilesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsterProfilesRetrieve<TData = Awaited<ReturnType<typeof stafferGigsterProfilesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsterProfilesRetrieve<TData = Awaited<ReturnType<typeof stafferGigsterProfilesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsterProfilesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsterProfilesProPreferencesCreateUrl = (proId: number,) => {




  return `/api/staffer/gigster-profiles/${proId}/pro-preferences/`
}

/**
 * Writable nested pro-preferences create endpoint for managers, gigpro admins, and the
 * qwick-mcp-agent-admin M2M token used by the AI-interviewer ingest pipeline (CORE-5870).
 *
 * Mounted at ``/api/staffer/gigster-profiles/{pro_id}/pro-preferences/``. The target pro
 * is taken from the ``pro_id`` URL kwarg — NOT ``request.user`` — which is what lets the
 * M2M agent write preferences for arbitrary pros.
 *
 * Returns 409 if the target pro already has a pro_preferences row; callers should PATCH
 * the existing row at ``/api/pro-preferences/{id}/`` instead. PATCH/PUT/DELETE are not
 * exposed here — only create.
 */
export const stafferGigsterProfilesProPreferencesCreate = async (proId: number,
    stafferProPreferencesRequest?: StafferProPreferencesRequest, options?: Parameters<typeof customFetch>[1]): Promise<StafferProPreferences> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<StafferProPreferences>(getStafferGigsterProfilesProPreferencesCreateUrl(proId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(stafferProPreferencesRequest)
  }
);}





export const getStafferGigsterProfilesProPreferencesCreateMutationKey = () => ['stafferGigsterProfilesProPreferencesCreate'] as const;

export const getStafferGigsterProfilesProPreferencesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsterProfilesProPreferencesCreate>>, TError,StafferGigsterProfilesProPreferencesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsterProfilesProPreferencesCreate>>, TError,StafferGigsterProfilesProPreferencesCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigsterProfilesProPreferencesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsterProfilesProPreferencesCreate>>, StafferGigsterProfilesProPreferencesCreateMutationVariables> = (props) => {
          const {proId,data} = props ?? {};

          return  stafferGigsterProfilesProPreferencesCreate(proId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsterProfilesProPreferencesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsterProfilesProPreferencesCreate>>>
    export type StafferGigsterProfilesProPreferencesCreateMutationBody = StafferProPreferencesRequest | undefined
    export type StafferGigsterProfilesProPreferencesCreateMutationError = void
    export type StafferGigsterProfilesProPreferencesCreateMutationVariables = {proId: number;data?: StafferProPreferencesRequest}

    export const useStafferGigsterProfilesProPreferencesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsterProfilesProPreferencesCreate>>, TError,StafferGigsterProfilesProPreferencesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsterProfilesProPreferencesCreate>>,
        TError,
        StafferGigsterProfilesProPreferencesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsterProfilesProPreferencesCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigsterProfilesWorkHistoryRecordsCreateUrl = (proId: number,) => {




  return `/api/staffer/gigster-profiles/${proId}/work-history-records/`
}

/**
 * Writable nested work-history endpoint for managers, gigpro admins, and the
 * qwick-mcp-agent-admin M2M token used by the AI-interviewer ingest pipeline.
 *
 * Mounted at ``/api/staffer/gigster-profiles/{id}/work-history-records/{record_id?}/``.
 * The target pro is taken from the ``id`` URL kwarg — NOT ``request.user`` — which
 * is what lets the M2M agent write records for arbitrary pros (CORE-5518).
 */
export const stafferGigsterProfilesWorkHistoryRecordsCreate = async (proId: number,
    workHistoryRecordRequest: WorkHistoryRecordRequest, options?: Parameters<typeof customFetch>[1]): Promise<WorkHistoryRecord> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<WorkHistoryRecord>(getStafferGigsterProfilesWorkHistoryRecordsCreateUrl(proId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workHistoryRecordRequest)
  }
);}





export const getStafferGigsterProfilesWorkHistoryRecordsCreateMutationKey = () => ['stafferGigsterProfilesWorkHistoryRecordsCreate'] as const;

export const getStafferGigsterProfilesWorkHistoryRecordsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsCreate>>, TError,StafferGigsterProfilesWorkHistoryRecordsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsCreate>>, TError,StafferGigsterProfilesWorkHistoryRecordsCreateMutationVariables, TContext> => {

const mutationKey = getStafferGigsterProfilesWorkHistoryRecordsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsCreate>>, StafferGigsterProfilesWorkHistoryRecordsCreateMutationVariables> = (props) => {
          const {proId,data} = props ?? {};

          return  stafferGigsterProfilesWorkHistoryRecordsCreate(proId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsterProfilesWorkHistoryRecordsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsCreate>>>
    export type StafferGigsterProfilesWorkHistoryRecordsCreateMutationBody = WorkHistoryRecordRequest
    export type StafferGigsterProfilesWorkHistoryRecordsCreateMutationError = void
    export type StafferGigsterProfilesWorkHistoryRecordsCreateMutationVariables = {proId: number;data: WorkHistoryRecordRequest}

    export const useStafferGigsterProfilesWorkHistoryRecordsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsCreate>>, TError,StafferGigsterProfilesWorkHistoryRecordsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsCreate>>,
        TError,
        StafferGigsterProfilesWorkHistoryRecordsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsterProfilesWorkHistoryRecordsCreateMutationOptions(options), queryClient);
    }
    export const getStafferGigsterProfilesWorkHistoryRecordsUpdateUrl = (proId: number,
    id: number,) => {




  return `/api/staffer/gigster-profiles/${proId}/work-history-records/${id}/`
}

/**
 * Writable nested work-history endpoint for managers, gigpro admins, and the
 * qwick-mcp-agent-admin M2M token used by the AI-interviewer ingest pipeline.
 *
 * Mounted at ``/api/staffer/gigster-profiles/{id}/work-history-records/{record_id?}/``.
 * The target pro is taken from the ``id`` URL kwarg — NOT ``request.user`` — which
 * is what lets the M2M agent write records for arbitrary pros (CORE-5518).
 */
export const stafferGigsterProfilesWorkHistoryRecordsUpdate = async (proId: number,
    id: number,
    workHistoryRecordRequest: WorkHistoryRecordRequest, options?: Parameters<typeof customFetch>[1]): Promise<WorkHistoryRecord> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<WorkHistoryRecord>(getStafferGigsterProfilesWorkHistoryRecordsUpdateUrl(proId,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workHistoryRecordRequest)
  }
);}





export const getStafferGigsterProfilesWorkHistoryRecordsUpdateMutationKey = () => ['stafferGigsterProfilesWorkHistoryRecordsUpdate'] as const;

export const getStafferGigsterProfilesWorkHistoryRecordsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsUpdate>>, TError,StafferGigsterProfilesWorkHistoryRecordsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsUpdate>>, TError,StafferGigsterProfilesWorkHistoryRecordsUpdateMutationVariables, TContext> => {

const mutationKey = getStafferGigsterProfilesWorkHistoryRecordsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsUpdate>>, StafferGigsterProfilesWorkHistoryRecordsUpdateMutationVariables> = (props) => {
          const {proId,id,data} = props ?? {};

          return  stafferGigsterProfilesWorkHistoryRecordsUpdate(proId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsterProfilesWorkHistoryRecordsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsUpdate>>>
    export type StafferGigsterProfilesWorkHistoryRecordsUpdateMutationBody = WorkHistoryRecordRequest
    export type StafferGigsterProfilesWorkHistoryRecordsUpdateMutationError = void
    export type StafferGigsterProfilesWorkHistoryRecordsUpdateMutationVariables = {proId: number;id: number;data: WorkHistoryRecordRequest}

    export const useStafferGigsterProfilesWorkHistoryRecordsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsUpdate>>, TError,StafferGigsterProfilesWorkHistoryRecordsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsUpdate>>,
        TError,
        StafferGigsterProfilesWorkHistoryRecordsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsterProfilesWorkHistoryRecordsUpdateMutationOptions(options), queryClient);
    }
    export const getStafferGigsterProfilesWorkHistoryRecordsPartialUpdateUrl = (proId: number,
    id: number,) => {




  return `/api/staffer/gigster-profiles/${proId}/work-history-records/${id}/`
}

/**
 * Writable nested work-history endpoint for managers, gigpro admins, and the
 * qwick-mcp-agent-admin M2M token used by the AI-interviewer ingest pipeline.
 *
 * Mounted at ``/api/staffer/gigster-profiles/{id}/work-history-records/{record_id?}/``.
 * The target pro is taken from the ``id`` URL kwarg — NOT ``request.user`` — which
 * is what lets the M2M agent write records for arbitrary pros (CORE-5518).
 */
export const stafferGigsterProfilesWorkHistoryRecordsPartialUpdate = async (proId: number,
    id: number,
    patchedWorkHistoryRecordRequest?: PatchedWorkHistoryRecordRequest, options?: Parameters<typeof customFetch>[1]): Promise<WorkHistoryRecord> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<WorkHistoryRecord>(getStafferGigsterProfilesWorkHistoryRecordsPartialUpdateUrl(proId,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedWorkHistoryRecordRequest)
  }
);}





export const getStafferGigsterProfilesWorkHistoryRecordsPartialUpdateMutationKey = () => ['stafferGigsterProfilesWorkHistoryRecordsPartialUpdate'] as const;

export const getStafferGigsterProfilesWorkHistoryRecordsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsPartialUpdate>>, TError,StafferGigsterProfilesWorkHistoryRecordsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsPartialUpdate>>, TError,StafferGigsterProfilesWorkHistoryRecordsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getStafferGigsterProfilesWorkHistoryRecordsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsPartialUpdate>>, StafferGigsterProfilesWorkHistoryRecordsPartialUpdateMutationVariables> = (props) => {
          const {proId,id,data} = props ?? {};

          return  stafferGigsterProfilesWorkHistoryRecordsPartialUpdate(proId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsterProfilesWorkHistoryRecordsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsPartialUpdate>>>
    export type StafferGigsterProfilesWorkHistoryRecordsPartialUpdateMutationBody = PatchedWorkHistoryRecordRequest | undefined
    export type StafferGigsterProfilesWorkHistoryRecordsPartialUpdateMutationError = void
    export type StafferGigsterProfilesWorkHistoryRecordsPartialUpdateMutationVariables = {proId: number;id: number;data?: PatchedWorkHistoryRecordRequest}

    export const useStafferGigsterProfilesWorkHistoryRecordsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsPartialUpdate>>, TError,StafferGigsterProfilesWorkHistoryRecordsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsPartialUpdate>>,
        TError,
        StafferGigsterProfilesWorkHistoryRecordsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsterProfilesWorkHistoryRecordsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getStafferGigsterProfilesWorkHistoryRecordsDestroyUrl = (proId: number,
    id: number,) => {




  return `/api/staffer/gigster-profiles/${proId}/work-history-records/${id}/`
}

/**
 * Writable nested work-history endpoint for managers, gigpro admins, and the
 * qwick-mcp-agent-admin M2M token used by the AI-interviewer ingest pipeline.
 *
 * Mounted at ``/api/staffer/gigster-profiles/{id}/work-history-records/{record_id?}/``.
 * The target pro is taken from the ``id`` URL kwarg — NOT ``request.user`` — which
 * is what lets the M2M agent write records for arbitrary pros (CORE-5518).
 */
export const stafferGigsterProfilesWorkHistoryRecordsDestroy = async (proId: number,
    id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getStafferGigsterProfilesWorkHistoryRecordsDestroyUrl(proId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getStafferGigsterProfilesWorkHistoryRecordsDestroyMutationKey = () => ['stafferGigsterProfilesWorkHistoryRecordsDestroy'] as const;

export const getStafferGigsterProfilesWorkHistoryRecordsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsDestroy>>, TError,StafferGigsterProfilesWorkHistoryRecordsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsDestroy>>, TError,StafferGigsterProfilesWorkHistoryRecordsDestroyMutationVariables, TContext> => {

const mutationKey = getStafferGigsterProfilesWorkHistoryRecordsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsDestroy>>, StafferGigsterProfilesWorkHistoryRecordsDestroyMutationVariables> = (props) => {
          const {proId,id} = props ?? {};

          return  stafferGigsterProfilesWorkHistoryRecordsDestroy(proId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferGigsterProfilesWorkHistoryRecordsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsDestroy>>>

    export type StafferGigsterProfilesWorkHistoryRecordsDestroyMutationError = void
    export type StafferGigsterProfilesWorkHistoryRecordsDestroyMutationVariables = {proId: number;id: number}

    export const useStafferGigsterProfilesWorkHistoryRecordsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsDestroy>>, TError,StafferGigsterProfilesWorkHistoryRecordsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferGigsterProfilesWorkHistoryRecordsDestroy>>,
        TError,
        StafferGigsterProfilesWorkHistoryRecordsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getStafferGigsterProfilesWorkHistoryRecordsDestroyMutationOptions(options), queryClient);
    }
    export const getStafferGigsterProfilesAvailabilityListUrl = (params: StafferGigsterProfilesAvailabilityListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gigster-profiles/availability/?${stringifiedParams}` : `/api/staffer/gigster-profiles/availability/`
}

/**
 * This API is designed for managers to retrieve the availability of a list of Pros.
 *
 * Features:
 * - Supports profile_ids (comma-separated GigsterProfile IDs) and/or user_ids
 *   (comma-separated User IDs) and/or group_id
 * - user_ids can be passed as: ?user_ids=1,2,3
 * - Parameters can be used independently or combined together
 * - Enhanced response with availability_status field ("available"/"unavailable")
 * - Automatic deduplication when combining multiple ID sources
 * - Backward compatible with existing integrations
 */
export const stafferGigsterProfilesAvailabilityList = async (params: StafferGigsterProfilesAvailabilityListParams, options?: Parameters<typeof customFetch>[1]): Promise<ProAvailability[]> => {

  return customFetch<ProAvailability[]>(getStafferGigsterProfilesAvailabilityListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsterProfilesAvailabilityListQueryKey = (params?: StafferGigsterProfilesAvailabilityListParams,) => {
    return [
    `/api/staffer/gigster-profiles/availability/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferGigsterProfilesAvailabilityListQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsterProfilesAvailabilityList>>, TError = void>(params: StafferGigsterProfilesAvailabilityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesAvailabilityList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsterProfilesAvailabilityListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsterProfilesAvailabilityList>>> = ({ signal }) => stafferGigsterProfilesAvailabilityList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesAvailabilityList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsterProfilesAvailabilityListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsterProfilesAvailabilityList>>>
export type StafferGigsterProfilesAvailabilityListQueryError = void


export function useStafferGigsterProfilesAvailabilityList<TData = Awaited<ReturnType<typeof stafferGigsterProfilesAvailabilityList>>, TError = void>(
 params: StafferGigsterProfilesAvailabilityListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesAvailabilityList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsterProfilesAvailabilityList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsterProfilesAvailabilityList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsterProfilesAvailabilityList<TData = Awaited<ReturnType<typeof stafferGigsterProfilesAvailabilityList>>, TError = void>(
 params: StafferGigsterProfilesAvailabilityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesAvailabilityList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsterProfilesAvailabilityList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsterProfilesAvailabilityList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsterProfilesAvailabilityList<TData = Awaited<ReturnType<typeof stafferGigsterProfilesAvailabilityList>>, TError = void>(
 params: StafferGigsterProfilesAvailabilityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesAvailabilityList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsterProfilesAvailabilityList<TData = Awaited<ReturnType<typeof stafferGigsterProfilesAvailabilityList>>, TError = void>(
 params: StafferGigsterProfilesAvailabilityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesAvailabilityList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsterProfilesAvailabilityListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsterProfilesSearchListUrl = (params?: StafferGigsterProfilesSearchListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/gigster-profiles/search/?${stringifiedParams}` : `/api/staffer/gigster-profiles/search/`
}

/**
 * This API is designed for managers to retrieve a filtered list of Pro profiles for
 * the Find a Pro page, it finds Pros across Gigpro.
 */
export const stafferGigsterProfilesSearchList = async (params?: StafferGigsterProfilesSearchListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedFindProList> => {

  return customFetch<PaginatedFindProList>(getStafferGigsterProfilesSearchListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferGigsterProfilesSearchListInfiniteQueryKey = (params?: StafferGigsterProfilesSearchListParams,) => {
    return [
    'infinite', `/api/staffer/gigster-profiles/search/`, ...(params ? [params] : [])
    ] as const;
    }

export const getStafferGigsterProfilesSearchListQueryKey = (params?: StafferGigsterProfilesSearchListParams,) => {
    return [
    `/api/staffer/gigster-profiles/search/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferGigsterProfilesSearchListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, StafferGigsterProfilesSearchListParams['page']>, TError = void>(params?: StafferGigsterProfilesSearchListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, TError, TData, QueryKey, StafferGigsterProfilesSearchListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsterProfilesSearchListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, QueryKey, StafferGigsterProfilesSearchListParams['page']> = ({ signal, pageParam }) => stafferGigsterProfilesSearchList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, TError, TData, QueryKey, StafferGigsterProfilesSearchListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsterProfilesSearchListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>>
export type StafferGigsterProfilesSearchListInfiniteQueryError = void


export function useStafferGigsterProfilesSearchListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, StafferGigsterProfilesSearchListParams['page']>, TError = void>(
 params: undefined |  StafferGigsterProfilesSearchListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, TError, TData, QueryKey, StafferGigsterProfilesSearchListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsterProfilesSearchListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, StafferGigsterProfilesSearchListParams['page']>, TError = void>(
 params?: StafferGigsterProfilesSearchListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, TError, TData, QueryKey, StafferGigsterProfilesSearchListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsterProfilesSearchListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, StafferGigsterProfilesSearchListParams['page']>, TError = void>(
 params?: StafferGigsterProfilesSearchListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, TError, TData, QueryKey, StafferGigsterProfilesSearchListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsterProfilesSearchListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, StafferGigsterProfilesSearchListParams['page']>, TError = void>(
 params?: StafferGigsterProfilesSearchListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, TError, TData, QueryKey, StafferGigsterProfilesSearchListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsterProfilesSearchListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferGigsterProfilesSearchListQueryOptions = <TData = Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, TError = void>(params?: StafferGigsterProfilesSearchListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferGigsterProfilesSearchListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>> = ({ signal }) => stafferGigsterProfilesSearchList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferGigsterProfilesSearchListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>>
export type StafferGigsterProfilesSearchListQueryError = void


export function useStafferGigsterProfilesSearchList<TData = Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, TError = void>(
 params: undefined |  StafferGigsterProfilesSearchListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsterProfilesSearchList<TData = Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, TError = void>(
 params?: StafferGigsterProfilesSearchListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>,
          TError,
          Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferGigsterProfilesSearchList<TData = Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, TError = void>(
 params?: StafferGigsterProfilesSearchListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferGigsterProfilesSearchList<TData = Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, TError = void>(
 params?: StafferGigsterProfilesSearchListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferGigsterProfilesSearchList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferGigsterProfilesSearchListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferOrganizationManagersDestroyUrl = (id: number,) => {




  return `/api/staffer/organization-managers/${id}/`
}

/**
 * A view mixin that will load the user id of the user that triggered the action. This gets
 * passed through to signal handlers so they can know who signaled the action.
 *
 * Note: You typically DO NOT have to use this type of pass through for updates and saves
 * b/c you'll inherently have a record/instance with a last_updated_by field. When deleting,
 * the records last_updated_by isn't necessarily the id of the person deleting the record,
 * therefore this strategy has been implemented.
 */
export const stafferOrganizationManagersDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getStafferOrganizationManagersDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getStafferOrganizationManagersDestroyMutationKey = () => ['stafferOrganizationManagersDestroy'] as const;

export const getStafferOrganizationManagersDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationManagersDestroy>>, TError,StafferOrganizationManagersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationManagersDestroy>>, TError,StafferOrganizationManagersDestroyMutationVariables, TContext> => {

const mutationKey = getStafferOrganizationManagersDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferOrganizationManagersDestroy>>, StafferOrganizationManagersDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  stafferOrganizationManagersDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferOrganizationManagersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof stafferOrganizationManagersDestroy>>>

    export type StafferOrganizationManagersDestroyMutationError = void
    export type StafferOrganizationManagersDestroyMutationVariables = {id: number}

    export const useStafferOrganizationManagersDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationManagersDestroy>>, TError,StafferOrganizationManagersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferOrganizationManagersDestroy>>,
        TError,
        StafferOrganizationManagersDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getStafferOrganizationManagersDestroyMutationOptions(options), queryClient);
    }
    export const getStafferOrganizationsListUrl = (params?: StafferOrganizationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/organizations/?${stringifiedParams}` : `/api/staffer/organizations/`
}

/**
 * An organization is a collection of users and locations.
 */
export const stafferOrganizationsList = async (params?: StafferOrganizationsListParams, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationListResponse[]> => {

  return customFetch<OrganizationListResponse[]>(getStafferOrganizationsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferOrganizationsListQueryKey = (params?: StafferOrganizationsListParams,) => {
    return [
    `/api/staffer/organizations/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferOrganizationsListQueryOptions = <TData = Awaited<ReturnType<typeof stafferOrganizationsList>>, TError = void>(params?: StafferOrganizationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferOrganizationsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferOrganizationsList>>> = ({ signal }) => stafferOrganizationsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferOrganizationsListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferOrganizationsList>>>
export type StafferOrganizationsListQueryError = void


export function useStafferOrganizationsList<TData = Awaited<ReturnType<typeof stafferOrganizationsList>>, TError = void>(
 params: undefined |  StafferOrganizationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsList>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsList<TData = Awaited<ReturnType<typeof stafferOrganizationsList>>, TError = void>(
 params?: StafferOrganizationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsList>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsList<TData = Awaited<ReturnType<typeof stafferOrganizationsList>>, TError = void>(
 params?: StafferOrganizationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferOrganizationsList<TData = Awaited<ReturnType<typeof stafferOrganizationsList>>, TError = void>(
 params?: StafferOrganizationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferOrganizationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferOrganizationsInvitationsListUrl = (orgId: string,) => {




  return `/api/staffer/organizations/${orgId}/invitations/`
}

export const stafferOrganizationsInvitationsList = async (orgId: string, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationInvitation[]> => {

  return customFetch<OrganizationInvitation[]>(getStafferOrganizationsInvitationsListUrl(orgId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferOrganizationsInvitationsListQueryKey = (orgId: string,) => {
    return [
    `/api/staffer/organizations/${orgId}/invitations/`
    ] as const;
    }


export const getStafferOrganizationsInvitationsListQueryOptions = <TData = Awaited<ReturnType<typeof stafferOrganizationsInvitationsList>>, TError = void>(orgId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferOrganizationsInvitationsListQueryKey(orgId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferOrganizationsInvitationsList>>> = ({ signal }) => stafferOrganizationsInvitationsList(orgId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: orgId !== null && orgId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferOrganizationsInvitationsListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferOrganizationsInvitationsList>>>
export type StafferOrganizationsInvitationsListQueryError = void


export function useStafferOrganizationsInvitationsList<TData = Awaited<ReturnType<typeof stafferOrganizationsInvitationsList>>, TError = void>(
 orgId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsInvitationsList>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsInvitationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsInvitationsList<TData = Awaited<ReturnType<typeof stafferOrganizationsInvitationsList>>, TError = void>(
 orgId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsInvitationsList>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsInvitationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsInvitationsList<TData = Awaited<ReturnType<typeof stafferOrganizationsInvitationsList>>, TError = void>(
 orgId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferOrganizationsInvitationsList<TData = Awaited<ReturnType<typeof stafferOrganizationsInvitationsList>>, TError = void>(
 orgId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferOrganizationsInvitationsListQueryOptions(orgId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferOrganizationsInvitationsCreateUrl = (orgId: string,) => {




  return `/api/staffer/organizations/${orgId}/invitations/`
}

export const stafferOrganizationsInvitationsCreate = async (orgId: string,
    organizationInvitationRequest: OrganizationInvitationRequest, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationInvitation> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<OrganizationInvitation>(getStafferOrganizationsInvitationsCreateUrl(orgId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(organizationInvitationRequest)
  }
);}





export const getStafferOrganizationsInvitationsCreateMutationKey = () => ['stafferOrganizationsInvitationsCreate'] as const;

export const getStafferOrganizationsInvitationsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsCreate>>, TError,StafferOrganizationsInvitationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsCreate>>, TError,StafferOrganizationsInvitationsCreateMutationVariables, TContext> => {

const mutationKey = getStafferOrganizationsInvitationsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferOrganizationsInvitationsCreate>>, StafferOrganizationsInvitationsCreateMutationVariables> = (props) => {
          const {orgId,data} = props ?? {};

          return  stafferOrganizationsInvitationsCreate(orgId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferOrganizationsInvitationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferOrganizationsInvitationsCreate>>>
    export type StafferOrganizationsInvitationsCreateMutationBody = OrganizationInvitationRequest
    export type StafferOrganizationsInvitationsCreateMutationError = void
    export type StafferOrganizationsInvitationsCreateMutationVariables = {orgId: string;data: OrganizationInvitationRequest}

    export const useStafferOrganizationsInvitationsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsCreate>>, TError,StafferOrganizationsInvitationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferOrganizationsInvitationsCreate>>,
        TError,
        StafferOrganizationsInvitationsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferOrganizationsInvitationsCreateMutationOptions(options), queryClient);
    }
    export const getStafferOrganizationsInvitationsDestroyUrl = (orgId: string,
    id: string,) => {




  return `/api/staffer/organizations/${orgId}/invitations/${id}/`
}

export const stafferOrganizationsInvitationsDestroy = async (orgId: string,
    id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getStafferOrganizationsInvitationsDestroyUrl(orgId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getStafferOrganizationsInvitationsDestroyMutationKey = () => ['stafferOrganizationsInvitationsDestroy'] as const;

export const getStafferOrganizationsInvitationsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsDestroy>>, TError,StafferOrganizationsInvitationsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsDestroy>>, TError,StafferOrganizationsInvitationsDestroyMutationVariables, TContext> => {

const mutationKey = getStafferOrganizationsInvitationsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferOrganizationsInvitationsDestroy>>, StafferOrganizationsInvitationsDestroyMutationVariables> = (props) => {
          const {orgId,id} = props ?? {};

          return  stafferOrganizationsInvitationsDestroy(orgId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferOrganizationsInvitationsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof stafferOrganizationsInvitationsDestroy>>>

    export type StafferOrganizationsInvitationsDestroyMutationError = void
    export type StafferOrganizationsInvitationsDestroyMutationVariables = {orgId: string;id: string}

    export const useStafferOrganizationsInvitationsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsDestroy>>, TError,StafferOrganizationsInvitationsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferOrganizationsInvitationsDestroy>>,
        TError,
        StafferOrganizationsInvitationsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getStafferOrganizationsInvitationsDestroyMutationOptions(options), queryClient);
    }
    export const getStafferOrganizationsInvitationsResendCreateUrl = (orgId: string,
    id: string,) => {




  return `/api/staffer/organizations/${orgId}/invitations/${id}/resend/`
}

export const stafferOrganizationsInvitationsResendCreate = async (orgId: string,
    id: string, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationInvitation> => {

  return customFetch<OrganizationInvitation>(getStafferOrganizationsInvitationsResendCreateUrl(orgId,id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStafferOrganizationsInvitationsResendCreateMutationKey = () => ['stafferOrganizationsInvitationsResendCreate'] as const;

export const getStafferOrganizationsInvitationsResendCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsResendCreate>>, TError,StafferOrganizationsInvitationsResendCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsResendCreate>>, TError,StafferOrganizationsInvitationsResendCreateMutationVariables, TContext> => {

const mutationKey = getStafferOrganizationsInvitationsResendCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferOrganizationsInvitationsResendCreate>>, StafferOrganizationsInvitationsResendCreateMutationVariables> = (props) => {
          const {orgId,id} = props ?? {};

          return  stafferOrganizationsInvitationsResendCreate(orgId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferOrganizationsInvitationsResendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferOrganizationsInvitationsResendCreate>>>

    export type StafferOrganizationsInvitationsResendCreateMutationError = void
    export type StafferOrganizationsInvitationsResendCreateMutationVariables = {orgId: string;id: string}

    export const useStafferOrganizationsInvitationsResendCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsResendCreate>>, TError,StafferOrganizationsInvitationsResendCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferOrganizationsInvitationsResendCreate>>,
        TError,
        StafferOrganizationsInvitationsResendCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferOrganizationsInvitationsResendCreateMutationOptions(options), queryClient);
    }
    export const getStafferOrganizationsRetrieveUrl = (id: string,) => {




  return `/api/staffer/organizations/${id}/`
}

/**
 * An organization is a collection of users and locations.
 */
export const stafferOrganizationsRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationRetrieveResponse> => {

  return customFetch<OrganizationRetrieveResponse>(getStafferOrganizationsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferOrganizationsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/staffer/organizations/${id}/`
    ] as const;
    }


export const getStafferOrganizationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferOrganizationsRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferOrganizationsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferOrganizationsRetrieve>>> = ({ signal }) => stafferOrganizationsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferOrganizationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferOrganizationsRetrieve>>>
export type StafferOrganizationsRetrieveQueryError = void


export function useStafferOrganizationsRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferOrganizationsRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferOrganizationsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferOrganizationsPartialUpdateUrl = (id: string,) => {




  return `/api/staffer/organizations/${id}/`
}

/**
 * An organization is a collection of users and locations.
 */
export const stafferOrganizationsPartialUpdate = async (id: string,
    patchedOrganizationPartialUpdateRequest?: PatchedOrganizationPartialUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationPartialUpdate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<OrganizationPartialUpdate>(getStafferOrganizationsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedOrganizationPartialUpdateRequest)
  }
);}





export const getStafferOrganizationsPartialUpdateMutationKey = () => ['stafferOrganizationsPartialUpdate'] as const;

export const getStafferOrganizationsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationsPartialUpdate>>, TError,StafferOrganizationsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationsPartialUpdate>>, TError,StafferOrganizationsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getStafferOrganizationsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferOrganizationsPartialUpdate>>, StafferOrganizationsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  stafferOrganizationsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferOrganizationsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferOrganizationsPartialUpdate>>>
    export type StafferOrganizationsPartialUpdateMutationBody = PatchedOrganizationPartialUpdateRequest | undefined
    export type StafferOrganizationsPartialUpdateMutationError = void
    export type StafferOrganizationsPartialUpdateMutationVariables = {id: string;data?: PatchedOrganizationPartialUpdateRequest}

    export const useStafferOrganizationsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationsPartialUpdate>>, TError,StafferOrganizationsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferOrganizationsPartialUpdate>>,
        TError,
        StafferOrganizationsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferOrganizationsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getStafferOrganizationsGigsListUrl = (id: string,
    params: StafferOrganizationsGigsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/organizations/${id}/gigs/?${stringifiedParams}` : `/api/staffer/organizations/${id}/gigs/`
}

/**
 * List individual gigs available to add to an event (EventGig-based).
 *
 * Parallel to organization_shifts but operates at the gig level.
 * Excludes gigs already assigned to any event by default.
 */
export const stafferOrganizationsGigsList = async (id: string,
    params: StafferOrganizationsGigsListParams, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationGigCandidate[]> => {

  return customFetch<OrganizationGigCandidate[]>(getStafferOrganizationsGigsListUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferOrganizationsGigsListQueryKey = (id: string,
    params?: StafferOrganizationsGigsListParams,) => {
    return [
    `/api/staffer/organizations/${id}/gigs/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferOrganizationsGigsListQueryOptions = <TData = Awaited<ReturnType<typeof stafferOrganizationsGigsList>>, TError = void>(id: string,
    params: StafferOrganizationsGigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsGigsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferOrganizationsGigsListQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferOrganizationsGigsList>>> = ({ signal }) => stafferOrganizationsGigsList(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsGigsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferOrganizationsGigsListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferOrganizationsGigsList>>>
export type StafferOrganizationsGigsListQueryError = void


export function useStafferOrganizationsGigsList<TData = Awaited<ReturnType<typeof stafferOrganizationsGigsList>>, TError = void>(
 id: string,
    params: StafferOrganizationsGigsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsGigsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsGigsList>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsGigsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsGigsList<TData = Awaited<ReturnType<typeof stafferOrganizationsGigsList>>, TError = void>(
 id: string,
    params: StafferOrganizationsGigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsGigsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsGigsList>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsGigsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsGigsList<TData = Awaited<ReturnType<typeof stafferOrganizationsGigsList>>, TError = void>(
 id: string,
    params: StafferOrganizationsGigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsGigsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferOrganizationsGigsList<TData = Awaited<ReturnType<typeof stafferOrganizationsGigsList>>, TError = void>(
 id: string,
    params: StafferOrganizationsGigsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsGigsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferOrganizationsGigsListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferOrganizationsInvoicingLinkRetrieveUrl = (id: string,) => {




  return `/api/staffer/organizations/${id}/invoicing-link/`
}

/**
 * An organization is a collection of users and locations.
 */
export const stafferOrganizationsInvoicingLinkRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<string> => {

  return customFetch<string>(getStafferOrganizationsInvoicingLinkRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferOrganizationsInvoicingLinkRetrieveQueryKey = (id: string,) => {
    return [
    `/api/staffer/organizations/${id}/invoicing-link/`
    ] as const;
    }


export const getStafferOrganizationsInvoicingLinkRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferOrganizationsInvoicingLinkRetrieve>>, TError = void | InvoicingLinkNotFound>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvoicingLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferOrganizationsInvoicingLinkRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferOrganizationsInvoicingLinkRetrieve>>> = ({ signal }) => stafferOrganizationsInvoicingLinkRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvoicingLinkRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferOrganizationsInvoicingLinkRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferOrganizationsInvoicingLinkRetrieve>>>
export type StafferOrganizationsInvoicingLinkRetrieveQueryError = void | InvoicingLinkNotFound


export function useStafferOrganizationsInvoicingLinkRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsInvoicingLinkRetrieve>>, TError = void | InvoicingLinkNotFound>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvoicingLinkRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsInvoicingLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsInvoicingLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsInvoicingLinkRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsInvoicingLinkRetrieve>>, TError = void | InvoicingLinkNotFound>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvoicingLinkRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsInvoicingLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsInvoicingLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsInvoicingLinkRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsInvoicingLinkRetrieve>>, TError = void | InvoicingLinkNotFound>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvoicingLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferOrganizationsInvoicingLinkRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsInvoicingLinkRetrieve>>, TError = void | InvoicingLinkNotFound>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvoicingLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferOrganizationsInvoicingLinkRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferOrganizationsLocationManagersListUrl = (id: string,) => {




  return `/api/staffer/organizations/${id}/location-managers/`
}

/**
 * An organization is a collection of users and locations.
 */
export const stafferOrganizationsLocationManagersList = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<LocationManager[]> => {

  return customFetch<LocationManager[]>(getStafferOrganizationsLocationManagersListUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferOrganizationsLocationManagersListQueryKey = (id: string,) => {
    return [
    `/api/staffer/organizations/${id}/location-managers/`
    ] as const;
    }


export const getStafferOrganizationsLocationManagersListQueryOptions = <TData = Awaited<ReturnType<typeof stafferOrganizationsLocationManagersList>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsLocationManagersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferOrganizationsLocationManagersListQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferOrganizationsLocationManagersList>>> = ({ signal }) => stafferOrganizationsLocationManagersList(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsLocationManagersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferOrganizationsLocationManagersListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferOrganizationsLocationManagersList>>>
export type StafferOrganizationsLocationManagersListQueryError = void


export function useStafferOrganizationsLocationManagersList<TData = Awaited<ReturnType<typeof stafferOrganizationsLocationManagersList>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsLocationManagersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsLocationManagersList>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsLocationManagersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsLocationManagersList<TData = Awaited<ReturnType<typeof stafferOrganizationsLocationManagersList>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsLocationManagersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsLocationManagersList>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsLocationManagersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsLocationManagersList<TData = Awaited<ReturnType<typeof stafferOrganizationsLocationManagersList>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsLocationManagersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferOrganizationsLocationManagersList<TData = Awaited<ReturnType<typeof stafferOrganizationsLocationManagersList>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsLocationManagersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferOrganizationsLocationManagersListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferOrganizationsOrganizationManagersListUrl = (id: string,) => {




  return `/api/staffer/organizations/${id}/organization-managers/`
}

/**
 * An organization is a collection of users and locations.
 */
export const stafferOrganizationsOrganizationManagersList = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationManager[]> => {

  return customFetch<OrganizationManager[]>(getStafferOrganizationsOrganizationManagersListUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferOrganizationsOrganizationManagersListQueryKey = (id: string,) => {
    return [
    `/api/staffer/organizations/${id}/organization-managers/`
    ] as const;
    }


export const getStafferOrganizationsOrganizationManagersListQueryOptions = <TData = Awaited<ReturnType<typeof stafferOrganizationsOrganizationManagersList>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsOrganizationManagersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferOrganizationsOrganizationManagersListQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferOrganizationsOrganizationManagersList>>> = ({ signal }) => stafferOrganizationsOrganizationManagersList(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsOrganizationManagersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferOrganizationsOrganizationManagersListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferOrganizationsOrganizationManagersList>>>
export type StafferOrganizationsOrganizationManagersListQueryError = void


export function useStafferOrganizationsOrganizationManagersList<TData = Awaited<ReturnType<typeof stafferOrganizationsOrganizationManagersList>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsOrganizationManagersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsOrganizationManagersList>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsOrganizationManagersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsOrganizationManagersList<TData = Awaited<ReturnType<typeof stafferOrganizationsOrganizationManagersList>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsOrganizationManagersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsOrganizationManagersList>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsOrganizationManagersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsOrganizationManagersList<TData = Awaited<ReturnType<typeof stafferOrganizationsOrganizationManagersList>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsOrganizationManagersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferOrganizationsOrganizationManagersList<TData = Awaited<ReturnType<typeof stafferOrganizationsOrganizationManagersList>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsOrganizationManagersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferOrganizationsOrganizationManagersListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferOrganizationsPaymentMethodRetrieveUrl = (id: string,) => {




  return `/api/staffer/organizations/${id}/payment-method/`
}

/**
 * Retrieves a summary of the location's payment_method from Stripe if configured.
 */
export const stafferOrganizationsPaymentMethodRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<OrgBillingInfo> => {

  return customFetch<OrgBillingInfo>(getStafferOrganizationsPaymentMethodRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferOrganizationsPaymentMethodRetrieveQueryKey = (id: string,) => {
    return [
    `/api/staffer/organizations/${id}/payment-method/`
    ] as const;
    }


export const getStafferOrganizationsPaymentMethodRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferOrganizationsPaymentMethodRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsPaymentMethodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferOrganizationsPaymentMethodRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferOrganizationsPaymentMethodRetrieve>>> = ({ signal }) => stafferOrganizationsPaymentMethodRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsPaymentMethodRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferOrganizationsPaymentMethodRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferOrganizationsPaymentMethodRetrieve>>>
export type StafferOrganizationsPaymentMethodRetrieveQueryError = void


export function useStafferOrganizationsPaymentMethodRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsPaymentMethodRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsPaymentMethodRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsPaymentMethodRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsPaymentMethodRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsPaymentMethodRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsPaymentMethodRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsPaymentMethodRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsPaymentMethodRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsPaymentMethodRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsPaymentMethodRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsPaymentMethodRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsPaymentMethodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferOrganizationsPaymentMethodRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsPaymentMethodRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsPaymentMethodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferOrganizationsPaymentMethodRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferOrganizationsSetupIntentRetrieveUrl = (id: string,) => {




  return `/api/staffer/organizations/${id}/setup-intent/`
}

/**
 * Creates a Stripe SetupIntent id for the purpose of adding a payment method.
 */
export const stafferOrganizationsSetupIntentRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<OrgSetupIntentResponse> => {

  return customFetch<OrgSetupIntentResponse>(getStafferOrganizationsSetupIntentRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferOrganizationsSetupIntentRetrieveQueryKey = (id: string,) => {
    return [
    `/api/staffer/organizations/${id}/setup-intent/`
    ] as const;
    }


export const getStafferOrganizationsSetupIntentRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferOrganizationsSetupIntentRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsSetupIntentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferOrganizationsSetupIntentRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferOrganizationsSetupIntentRetrieve>>> = ({ signal }) => stafferOrganizationsSetupIntentRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsSetupIntentRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferOrganizationsSetupIntentRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferOrganizationsSetupIntentRetrieve>>>
export type StafferOrganizationsSetupIntentRetrieveQueryError = void


export function useStafferOrganizationsSetupIntentRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsSetupIntentRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsSetupIntentRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsSetupIntentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsSetupIntentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsSetupIntentRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsSetupIntentRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsSetupIntentRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsSetupIntentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsSetupIntentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsSetupIntentRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsSetupIntentRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsSetupIntentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferOrganizationsSetupIntentRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsSetupIntentRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsSetupIntentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferOrganizationsSetupIntentRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferOrganizationsShiftsListUrl = (id: string,
    params: StafferOrganizationsShiftsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/organizations/${id}/shifts/?${stringifiedParams}` : `/api/staffer/organizations/${id}/shifts/`
}

/**
 * An organization is a collection of users and locations.
 */
export const stafferOrganizationsShiftsList = async (id: string,
    params: StafferOrganizationsShiftsListParams, options?: Parameters<typeof customFetch>[1]): Promise<GigShiftSerializerWithGigs[]> => {

  return customFetch<GigShiftSerializerWithGigs[]>(getStafferOrganizationsShiftsListUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferOrganizationsShiftsListQueryKey = (id: string,
    params?: StafferOrganizationsShiftsListParams,) => {
    return [
    `/api/staffer/organizations/${id}/shifts/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferOrganizationsShiftsListQueryOptions = <TData = Awaited<ReturnType<typeof stafferOrganizationsShiftsList>>, TError = void>(id: string,
    params: StafferOrganizationsShiftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsShiftsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferOrganizationsShiftsListQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferOrganizationsShiftsList>>> = ({ signal }) => stafferOrganizationsShiftsList(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsShiftsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferOrganizationsShiftsListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferOrganizationsShiftsList>>>
export type StafferOrganizationsShiftsListQueryError = void


export function useStafferOrganizationsShiftsList<TData = Awaited<ReturnType<typeof stafferOrganizationsShiftsList>>, TError = void>(
 id: string,
    params: StafferOrganizationsShiftsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsShiftsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsShiftsList>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsShiftsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsShiftsList<TData = Awaited<ReturnType<typeof stafferOrganizationsShiftsList>>, TError = void>(
 id: string,
    params: StafferOrganizationsShiftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsShiftsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsShiftsList>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsShiftsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsShiftsList<TData = Awaited<ReturnType<typeof stafferOrganizationsShiftsList>>, TError = void>(
 id: string,
    params: StafferOrganizationsShiftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsShiftsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferOrganizationsShiftsList<TData = Awaited<ReturnType<typeof stafferOrganizationsShiftsList>>, TError = void>(
 id: string,
    params: StafferOrganizationsShiftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsShiftsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferOrganizationsShiftsListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferOrganizationsInvitationsAcceptanceCreateUrl = (id: string,) => {




  return `/api/staffer/organizations/invitations/${id}/acceptance/`
}

/**
 * Viewset for accepting invitations to organizations.
 */
export const stafferOrganizationsInvitationsAcceptanceCreate = async (id: string,
    acceptOrganizationInvitationRequestRequest?: AcceptOrganizationInvitationRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationInvitation> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<OrganizationInvitation>(getStafferOrganizationsInvitationsAcceptanceCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(acceptOrganizationInvitationRequestRequest)
  }
);}





export const getStafferOrganizationsInvitationsAcceptanceCreateMutationKey = () => ['stafferOrganizationsInvitationsAcceptanceCreate'] as const;

export const getStafferOrganizationsInvitationsAcceptanceCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsAcceptanceCreate>>, TError,StafferOrganizationsInvitationsAcceptanceCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsAcceptanceCreate>>, TError,StafferOrganizationsInvitationsAcceptanceCreateMutationVariables, TContext> => {

const mutationKey = getStafferOrganizationsInvitationsAcceptanceCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferOrganizationsInvitationsAcceptanceCreate>>, StafferOrganizationsInvitationsAcceptanceCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  stafferOrganizationsInvitationsAcceptanceCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferOrganizationsInvitationsAcceptanceCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferOrganizationsInvitationsAcceptanceCreate>>>
    export type StafferOrganizationsInvitationsAcceptanceCreateMutationBody = AcceptOrganizationInvitationRequestRequest | undefined
    export type StafferOrganizationsInvitationsAcceptanceCreateMutationError = void
    export type StafferOrganizationsInvitationsAcceptanceCreateMutationVariables = {id: string;data?: AcceptOrganizationInvitationRequestRequest}

    export const useStafferOrganizationsInvitationsAcceptanceCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsAcceptanceCreate>>, TError,StafferOrganizationsInvitationsAcceptanceCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferOrganizationsInvitationsAcceptanceCreate>>,
        TError,
        StafferOrganizationsInvitationsAcceptanceCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferOrganizationsInvitationsAcceptanceCreateMutationOptions(options), queryClient);
    }
    export const getStafferOrganizationsInvitationsRetrieveUrl = (id: string,) => {




  return `/api/staffer/organizations/invitations/${id}/`
}

export const stafferOrganizationsInvitationsRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationInvitation> => {

  return customFetch<OrganizationInvitation>(getStafferOrganizationsInvitationsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferOrganizationsInvitationsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/staffer/organizations/invitations/${id}/`
    ] as const;
    }


export const getStafferOrganizationsInvitationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferOrganizationsInvitationsRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferOrganizationsInvitationsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferOrganizationsInvitationsRetrieve>>> = ({ signal }) => stafferOrganizationsInvitationsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferOrganizationsInvitationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferOrganizationsInvitationsRetrieve>>>
export type StafferOrganizationsInvitationsRetrieveQueryError = void


export function useStafferOrganizationsInvitationsRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsInvitationsRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsInvitationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsInvitationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsInvitationsRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsInvitationsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferOrganizationsInvitationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferOrganizationsInvitationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferOrganizationsInvitationsRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsInvitationsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferOrganizationsInvitationsRetrieve<TData = Awaited<ReturnType<typeof stafferOrganizationsInvitationsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferOrganizationsInvitationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferOrganizationsInvitationsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferPastHiresListUrl = (params: StafferPastHiresListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/past-hires/?${stringifiedParams}` : `/api/staffer/past-hires/`
}

/**
 * List distinct pros ('gigsters') who have at least one paid application at the requested location's organization. Ordered by most hired, then most recently worked.
 */
export const stafferPastHiresList = async (params: StafferPastHiresListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedStafferPastHireList> => {

  return customFetch<PaginatedStafferPastHireList>(getStafferPastHiresListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferPastHiresListInfiniteQueryKey = (params?: StafferPastHiresListParams,) => {
    return [
    'infinite', `/api/staffer/past-hires/`, ...(params ? [params] : [])
    ] as const;
    }

export const getStafferPastHiresListQueryKey = (params?: StafferPastHiresListParams,) => {
    return [
    `/api/staffer/past-hires/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferPastHiresListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof stafferPastHiresList>>, StafferPastHiresListParams['page']>, TError = void>(params: StafferPastHiresListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferPastHiresList>>, TError, TData, QueryKey, StafferPastHiresListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferPastHiresListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferPastHiresList>>, QueryKey, StafferPastHiresListParams['page']> = ({ signal, pageParam }) => stafferPastHiresList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferPastHiresList>>, TError, TData, QueryKey, StafferPastHiresListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferPastHiresListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof stafferPastHiresList>>>
export type StafferPastHiresListInfiniteQueryError = void


export function useStafferPastHiresListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferPastHiresList>>, StafferPastHiresListParams['page']>, TError = void>(
 params: StafferPastHiresListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferPastHiresList>>, TError, TData, QueryKey, StafferPastHiresListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferPastHiresList>>,
          TError,
          Awaited<ReturnType<typeof stafferPastHiresList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferPastHiresListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferPastHiresList>>, StafferPastHiresListParams['page']>, TError = void>(
 params: StafferPastHiresListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferPastHiresList>>, TError, TData, QueryKey, StafferPastHiresListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferPastHiresList>>,
          TError,
          Awaited<ReturnType<typeof stafferPastHiresList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferPastHiresListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferPastHiresList>>, StafferPastHiresListParams['page']>, TError = void>(
 params: StafferPastHiresListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferPastHiresList>>, TError, TData, QueryKey, StafferPastHiresListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferPastHiresListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof stafferPastHiresList>>, StafferPastHiresListParams['page']>, TError = void>(
 params: StafferPastHiresListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof stafferPastHiresList>>, TError, TData, QueryKey, StafferPastHiresListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferPastHiresListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferPastHiresListQueryOptions = <TData = Awaited<ReturnType<typeof stafferPastHiresList>>, TError = void>(params: StafferPastHiresListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferPastHiresList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferPastHiresListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferPastHiresList>>> = ({ signal }) => stafferPastHiresList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferPastHiresList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferPastHiresListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferPastHiresList>>>
export type StafferPastHiresListQueryError = void


export function useStafferPastHiresList<TData = Awaited<ReturnType<typeof stafferPastHiresList>>, TError = void>(
 params: StafferPastHiresListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferPastHiresList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferPastHiresList>>,
          TError,
          Awaited<ReturnType<typeof stafferPastHiresList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferPastHiresList<TData = Awaited<ReturnType<typeof stafferPastHiresList>>, TError = void>(
 params: StafferPastHiresListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferPastHiresList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferPastHiresList>>,
          TError,
          Awaited<ReturnType<typeof stafferPastHiresList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferPastHiresList<TData = Awaited<ReturnType<typeof stafferPastHiresList>>, TError = void>(
 params: StafferPastHiresListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferPastHiresList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferPastHiresList<TData = Awaited<ReturnType<typeof stafferPastHiresList>>, TError = void>(
 params: StafferPastHiresListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferPastHiresList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferPastHiresListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferProBlockListUrl = (params?: StafferProBlockListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/pro-block/?${stringifiedParams}` : `/api/staffer/pro-block/`
}

/**
 * This API is designed for gigpro admins to allow block/unblock Pros.
 *
 * A GigsterBlock represents a database record which is used to determine if a Pro is blocked in a location or not
 */
export const stafferProBlockList = async (params?: StafferProBlockListParams, options?: Parameters<typeof customFetch>[1]): Promise<GigsterBlockReadOnly[]> => {

  return customFetch<GigsterBlockReadOnly[]>(getStafferProBlockListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferProBlockListQueryKey = (params?: StafferProBlockListParams,) => {
    return [
    `/api/staffer/pro-block/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferProBlockListQueryOptions = <TData = Awaited<ReturnType<typeof stafferProBlockList>>, TError = void>(params?: StafferProBlockListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferProBlockList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferProBlockListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferProBlockList>>> = ({ signal }) => stafferProBlockList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferProBlockList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferProBlockListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferProBlockList>>>
export type StafferProBlockListQueryError = void


export function useStafferProBlockList<TData = Awaited<ReturnType<typeof stafferProBlockList>>, TError = void>(
 params: undefined |  StafferProBlockListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferProBlockList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferProBlockList>>,
          TError,
          Awaited<ReturnType<typeof stafferProBlockList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferProBlockList<TData = Awaited<ReturnType<typeof stafferProBlockList>>, TError = void>(
 params?: StafferProBlockListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferProBlockList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferProBlockList>>,
          TError,
          Awaited<ReturnType<typeof stafferProBlockList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferProBlockList<TData = Awaited<ReturnType<typeof stafferProBlockList>>, TError = void>(
 params?: StafferProBlockListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferProBlockList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferProBlockList<TData = Awaited<ReturnType<typeof stafferProBlockList>>, TError = void>(
 params?: StafferProBlockListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferProBlockList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferProBlockListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferProBlockCreateUrl = () => {




  return `/api/staffer/pro-block/`
}

/**
 * This API is designed for gigpro admins to allow block/unblock Pros.
 *
 * A GigsterBlock represents a database record which is used to determine if a Pro is blocked in a location or not
 */
export const stafferProBlockCreate = async (gigsterBlockMultiLocationRequest: GigsterBlockMultiLocationRequest, options?: Parameters<typeof customFetch>[1]): Promise<GigsterBlockMultiLocation> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GigsterBlockMultiLocation>(getStafferProBlockCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(gigsterBlockMultiLocationRequest)
  }
);}





export const getStafferProBlockCreateMutationKey = () => ['stafferProBlockCreate'] as const;

export const getStafferProBlockCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferProBlockCreate>>, TError,StafferProBlockCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferProBlockCreate>>, TError,StafferProBlockCreateMutationVariables, TContext> => {

const mutationKey = getStafferProBlockCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferProBlockCreate>>, StafferProBlockCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  stafferProBlockCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferProBlockCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferProBlockCreate>>>
    export type StafferProBlockCreateMutationBody = GigsterBlockMultiLocationRequest
    export type StafferProBlockCreateMutationError = void
    export type StafferProBlockCreateMutationVariables = {data: GigsterBlockMultiLocationRequest}

    export const useStafferProBlockCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferProBlockCreate>>, TError,StafferProBlockCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferProBlockCreate>>,
        TError,
        StafferProBlockCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferProBlockCreateMutationOptions(options), queryClient);
    }
    export const getStafferProBlockDestroyUrl = (id: number,) => {




  return `/api/staffer/pro-block/${id}/`
}

/**
 * This API is designed for gigpro admins to allow block/unblock Pros.
 *
 * A GigsterBlock represents a database record which is used to determine if a Pro is blocked in a location or not
 */
export const stafferProBlockDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getStafferProBlockDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getStafferProBlockDestroyMutationKey = () => ['stafferProBlockDestroy'] as const;

export const getStafferProBlockDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferProBlockDestroy>>, TError,StafferProBlockDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferProBlockDestroy>>, TError,StafferProBlockDestroyMutationVariables, TContext> => {

const mutationKey = getStafferProBlockDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferProBlockDestroy>>, StafferProBlockDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  stafferProBlockDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferProBlockDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof stafferProBlockDestroy>>>

    export type StafferProBlockDestroyMutationError = void
    export type StafferProBlockDestroyMutationVariables = {id: number}

    export const useStafferProBlockDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferProBlockDestroy>>, TError,StafferProBlockDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferProBlockDestroy>>,
        TError,
        StafferProBlockDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getStafferProBlockDestroyMutationOptions(options), queryClient);
    }
    export const getStafferTimeAndAttendanceRosterPdfRetrieveUrl = (params?: StafferTimeAndAttendanceRosterPdfRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/time-and-attendance/roster-pdf/?${stringifiedParams}` : `/api/staffer/time-and-attendance/roster-pdf/`
}

/**
 * Landscape roster PDF for the matched T&A scope: one section per shift date, location and venue, one row per confirmed pro. Rendered synchronously; rosters above the row cap are rejected.
 */
export const stafferTimeAndAttendanceRosterPdfRetrieve = async (params?: StafferTimeAndAttendanceRosterPdfRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<Blob> => {

  return customFetch<Blob>(getStafferTimeAndAttendanceRosterPdfRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferTimeAndAttendanceRosterPdfRetrieveQueryKey = (params?: StafferTimeAndAttendanceRosterPdfRetrieveParams,) => {
    return [
    `/api/staffer/time-and-attendance/roster-pdf/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferTimeAndAttendanceRosterPdfRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferTimeAndAttendanceRosterPdfRetrieve>>, TError = void>(params?: StafferTimeAndAttendanceRosterPdfRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferTimeAndAttendanceRosterPdfRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferTimeAndAttendanceRosterPdfRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferTimeAndAttendanceRosterPdfRetrieve>>> = ({ signal }) => stafferTimeAndAttendanceRosterPdfRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferTimeAndAttendanceRosterPdfRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferTimeAndAttendanceRosterPdfRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferTimeAndAttendanceRosterPdfRetrieve>>>
export type StafferTimeAndAttendanceRosterPdfRetrieveQueryError = void


export function useStafferTimeAndAttendanceRosterPdfRetrieve<TData = Awaited<ReturnType<typeof stafferTimeAndAttendanceRosterPdfRetrieve>>, TError = void>(
 params: undefined |  StafferTimeAndAttendanceRosterPdfRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferTimeAndAttendanceRosterPdfRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferTimeAndAttendanceRosterPdfRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferTimeAndAttendanceRosterPdfRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferTimeAndAttendanceRosterPdfRetrieve<TData = Awaited<ReturnType<typeof stafferTimeAndAttendanceRosterPdfRetrieve>>, TError = void>(
 params?: StafferTimeAndAttendanceRosterPdfRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferTimeAndAttendanceRosterPdfRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferTimeAndAttendanceRosterPdfRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferTimeAndAttendanceRosterPdfRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferTimeAndAttendanceRosterPdfRetrieve<TData = Awaited<ReturnType<typeof stafferTimeAndAttendanceRosterPdfRetrieve>>, TError = void>(
 params?: StafferTimeAndAttendanceRosterPdfRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferTimeAndAttendanceRosterPdfRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferTimeAndAttendanceRosterPdfRetrieve<TData = Awaited<ReturnType<typeof stafferTimeAndAttendanceRosterPdfRetrieve>>, TError = void>(
 params?: StafferTimeAndAttendanceRosterPdfRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferTimeAndAttendanceRosterPdfRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferTimeAndAttendanceRosterPdfRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferTimeAndAttendanceStatsRetrieveUrl = (params?: StafferTimeAndAttendanceStatsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/time-and-attendance/stats/?${stringifiedParams}` : `/api/staffer/time-and-attendance/stats/`
}

/**
 * Aggregate clock-status counts and last-activity timestamp for the matched T&A scope. Excludes shifts with no confirmed pros.
 */
export const stafferTimeAndAttendanceStatsRetrieve = async (params?: StafferTimeAndAttendanceStatsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<TimeAndAttendanceStats> => {

  return customFetch<TimeAndAttendanceStats>(getStafferTimeAndAttendanceStatsRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferTimeAndAttendanceStatsRetrieveQueryKey = (params?: StafferTimeAndAttendanceStatsRetrieveParams,) => {
    return [
    `/api/staffer/time-and-attendance/stats/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferTimeAndAttendanceStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferTimeAndAttendanceStatsRetrieve>>, TError = void>(params?: StafferTimeAndAttendanceStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferTimeAndAttendanceStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferTimeAndAttendanceStatsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferTimeAndAttendanceStatsRetrieve>>> = ({ signal }) => stafferTimeAndAttendanceStatsRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferTimeAndAttendanceStatsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferTimeAndAttendanceStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferTimeAndAttendanceStatsRetrieve>>>
export type StafferTimeAndAttendanceStatsRetrieveQueryError = void


export function useStafferTimeAndAttendanceStatsRetrieve<TData = Awaited<ReturnType<typeof stafferTimeAndAttendanceStatsRetrieve>>, TError = void>(
 params: undefined |  StafferTimeAndAttendanceStatsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferTimeAndAttendanceStatsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferTimeAndAttendanceStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferTimeAndAttendanceStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferTimeAndAttendanceStatsRetrieve<TData = Awaited<ReturnType<typeof stafferTimeAndAttendanceStatsRetrieve>>, TError = void>(
 params?: StafferTimeAndAttendanceStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferTimeAndAttendanceStatsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferTimeAndAttendanceStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferTimeAndAttendanceStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferTimeAndAttendanceStatsRetrieve<TData = Awaited<ReturnType<typeof stafferTimeAndAttendanceStatsRetrieve>>, TError = void>(
 params?: StafferTimeAndAttendanceStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferTimeAndAttendanceStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferTimeAndAttendanceStatsRetrieve<TData = Awaited<ReturnType<typeof stafferTimeAndAttendanceStatsRetrieve>>, TError = void>(
 params?: StafferTimeAndAttendanceStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferTimeAndAttendanceStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferTimeAndAttendanceStatsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferTosAcceptanceRetrieveUrl = (id: 'me',) => {




  return `/api/staffer/tos/acceptance/${id}/`
}

/**
 * TOS acceptance for Managers/Staffers (staffer endpoint)
 */
export const stafferTosAcceptanceRetrieve = async (id: 'me', options?: Parameters<typeof customFetch>[1]): Promise<TosStatus> => {

  return customFetch<TosStatus>(getStafferTosAcceptanceRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferTosAcceptanceRetrieveQueryKey = (id: 'me',) => {
    return [
    `/api/staffer/tos/acceptance/${id}/`
    ] as const;
    }


export const getStafferTosAcceptanceRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferTosAcceptanceRetrieve>>, TError = void>(id: 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferTosAcceptanceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferTosAcceptanceRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferTosAcceptanceRetrieve>>> = ({ signal }) => stafferTosAcceptanceRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferTosAcceptanceRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferTosAcceptanceRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferTosAcceptanceRetrieve>>>
export type StafferTosAcceptanceRetrieveQueryError = void


export function useStafferTosAcceptanceRetrieve<TData = Awaited<ReturnType<typeof stafferTosAcceptanceRetrieve>>, TError = void>(
 id: 'me', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferTosAcceptanceRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferTosAcceptanceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferTosAcceptanceRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferTosAcceptanceRetrieve<TData = Awaited<ReturnType<typeof stafferTosAcceptanceRetrieve>>, TError = void>(
 id: 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferTosAcceptanceRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferTosAcceptanceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferTosAcceptanceRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferTosAcceptanceRetrieve<TData = Awaited<ReturnType<typeof stafferTosAcceptanceRetrieve>>, TError = void>(
 id: 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferTosAcceptanceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferTosAcceptanceRetrieve<TData = Awaited<ReturnType<typeof stafferTosAcceptanceRetrieve>>, TError = void>(
 id: 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferTosAcceptanceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferTosAcceptanceRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferTosAcceptanceUpdateUrl = (id: 'me',) => {




  return `/api/staffer/tos/acceptance/${id}/`
}

/**
 * Accept the terms of service for the currently authenticated user.
 */
export const stafferTosAcceptanceUpdate = async (id: 'me', options?: Parameters<typeof customFetch>[1]): Promise<TosStatus> => {

  return customFetch<TosStatus>(getStafferTosAcceptanceUpdateUrl(id),
  {
    ...options,
    method: 'PUT'


  }
);}





export const getStafferTosAcceptanceUpdateMutationKey = () => ['stafferTosAcceptanceUpdate'] as const;

export const getStafferTosAcceptanceUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferTosAcceptanceUpdate>>, TError,StafferTosAcceptanceUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferTosAcceptanceUpdate>>, TError,StafferTosAcceptanceUpdateMutationVariables, TContext> => {

const mutationKey = getStafferTosAcceptanceUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferTosAcceptanceUpdate>>, StafferTosAcceptanceUpdateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  stafferTosAcceptanceUpdate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferTosAcceptanceUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferTosAcceptanceUpdate>>>

    export type StafferTosAcceptanceUpdateMutationError = void
    export type StafferTosAcceptanceUpdateMutationVariables = {id: 'me'}

    export const useStafferTosAcceptanceUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferTosAcceptanceUpdate>>, TError,StafferTosAcceptanceUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferTosAcceptanceUpdate>>,
        TError,
        StafferTosAcceptanceUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferTosAcceptanceUpdateMutationOptions(options), queryClient);
    }
    export const getStafferUsersListUrl = () => {




  return `/api/staffer/users/`
}

/**
 * A User represents a person who has access to Gigpro platform.
 *
 * This API is designed for GigPro admins to query the list of some "special" users like "Sales Agent" or "Partners".
 */
export const stafferUsersList = async ( options?: Parameters<typeof customFetch>[1]): Promise<UserResponse[]> => {

  return customFetch<UserResponse[]>(getStafferUsersListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferUsersListQueryKey = () => {
    return [
    `/api/staffer/users/`
    ] as const;
    }


export const getStafferUsersListQueryOptions = <TData = Awaited<ReturnType<typeof stafferUsersList>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferUsersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferUsersListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferUsersList>>> = ({ signal }) => stafferUsersList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferUsersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferUsersListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferUsersList>>>
export type StafferUsersListQueryError = void


export function useStafferUsersList<TData = Awaited<ReturnType<typeof stafferUsersList>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferUsersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferUsersList>>,
          TError,
          Awaited<ReturnType<typeof stafferUsersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferUsersList<TData = Awaited<ReturnType<typeof stafferUsersList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferUsersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferUsersList>>,
          TError,
          Awaited<ReturnType<typeof stafferUsersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferUsersList<TData = Awaited<ReturnType<typeof stafferUsersList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferUsersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useStafferUsersList<TData = Awaited<ReturnType<typeof stafferUsersList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferUsersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferUsersListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferUsersCheckHighDemandCreateUrl = () => {




  return `/api/staffer/users/check-high-demand/`
}

/**
 * Evaluate the High Demand Pros predicate for a hypothetical shift.
 *
 * Used by the create-shift / Offer Shift flow on Connect (WORK-4845): when a staffer
 * is composing a new shift, no ``Gig`` row exists yet, so the standard
 * ``annotate_high_demand`` paths cannot be reached. The front-end posts the
 * in-progress (location, pros, window) tuple here as ``start_time`` / ``end_time``
 * change, and renders the chip on the targeted pro / group from the response.
 *
 * Auth: caller must be an active manager of ``location_id`` — enforced by
 * ``IsLocationManagerPermission`` reading ``location_id`` from the request body.
 * ``Location.allow_high_demand_pros`` must be on for the predicate to be consulted;
 * otherwise the response is all-False with ``gates_active=false`` so the front-end can suppress the chip uniformly.
 */
export const stafferUsersCheckHighDemandCreate = async (checkHighDemandRequestRequest: CheckHighDemandRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<CheckHighDemandResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<CheckHighDemandResponse>(getStafferUsersCheckHighDemandCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(checkHighDemandRequestRequest)
  }
);}





export const getStafferUsersCheckHighDemandCreateMutationKey = () => ['stafferUsersCheckHighDemandCreate'] as const;

export const getStafferUsersCheckHighDemandCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferUsersCheckHighDemandCreate>>, TError,StafferUsersCheckHighDemandCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferUsersCheckHighDemandCreate>>, TError,StafferUsersCheckHighDemandCreateMutationVariables, TContext> => {

const mutationKey = getStafferUsersCheckHighDemandCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferUsersCheckHighDemandCreate>>, StafferUsersCheckHighDemandCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  stafferUsersCheckHighDemandCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferUsersCheckHighDemandCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferUsersCheckHighDemandCreate>>>
    export type StafferUsersCheckHighDemandCreateMutationBody = CheckHighDemandRequestRequest
    export type StafferUsersCheckHighDemandCreateMutationError = void
    export type StafferUsersCheckHighDemandCreateMutationVariables = {data: CheckHighDemandRequestRequest}

    export const useStafferUsersCheckHighDemandCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferUsersCheckHighDemandCreate>>, TError,StafferUsersCheckHighDemandCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferUsersCheckHighDemandCreate>>,
        TError,
        StafferUsersCheckHighDemandCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferUsersCheckHighDemandCreateMutationOptions(options), queryClient);
    }
